! function(e) {
    var t = e("body"),
        a = e(document),
        o = (e("html"), e(window));
    a.ready((() => {
        a.ajaxStart((() => {
            i.isAjaxLoading = !0
        })), a.ajaxStop((() => {
            i.isAjaxLoading = !1
        })), i.ready()
    })), window.onload = function() {
        i.init()
    };
    var i = {
        haloTimeout: null,
        isAjaxLoading: !1,
        ready: function() {
            this.loaderScript(), this.loaderProductBlock(), navigator.userAgent.match(/OS X.*Safari/) && !navigator.userAgent.match(/Chrome/) ? document.body.classList.add("safari") : document.body.classList.add("chrome");
            /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && document.body.classList.add("iOS"), t.hasClass("template-product") && (this.loaderRecommendationsBlock(), this.scrollToReview()), e("[data-product-tab-block]").length && this.clickedActiveProductTabs()
        },
        init: function() {
            this.initMultiTab();
this.initMultiTabMobile();
this.productBlockInfiniteScroll();
this.initGlobalCheckbox();
this.initColorSwatch();
this.initAddToCart();
this.initQuickShop();
this.initQuickCart();
this.initBeforeYouLeave();
this.initNotifyInStock();
this.initCompareProduct();
this.initWishlist();
this.initAskAnExpert();
this.closeAnnouncementBar();
this.sliderAnnouncementBar();
this.headerdropdownCurrency();
this.headerdropdownLanguage();
this.headerMasonry();
this.initLiveChat();
this.headerSidebarSearch();
this.headerStickySearchForm();
this.initCountdown();
this.collectionCountdown();
this.handleScrollDown();
this.initVideoPopup();
this.swapHoverVideoProductCard();
this.initDynamicBrowserTabTitle();
this.initWarningPopup();
this.initQuickView(); // Desktop pe already chal raha tha

// Mobile menu har screen size pe chalega
this.menuSidebarMobile();
this.menuSidebarMobileToggle();

// Banner animation initialize hoga agar class present ho
t.hasClass("banner-animation-1") && this.initBannerAnimation();

            const a = document.querySelectorAll(".breadcrumb-container");
            a.length > 0 && this.initBreadcrumbFadeout(a);
            const i = document.querySelectorAll(".media--loading-effect img"),
                n = document.getElementById("main-collection-product-grid");
            if ((i.length > 0 || n) && this.initLazyloadObserver(i, n), t.hasClass("show_effect_close") && this.backgroundOverlayHoverEffect(), window.innerWidth > 1024 && this.productMenuSlider(), e("[data-lookbook-icon]").length && this.addEventLookbookModal(), t.hasClass("template-page") && this.initWishlistPage(), t.hasClass("template-cart") && (this.initFreeShippingMessage(), this.updateGiftWrapper()), t.hasClass("template-product") && (this.initProductView(e(".halo-productView")), this.initProductBundle(), this.articleGallery(), this.toggleSidebarMobile(), this.initCollapseSidebarBlock(), this.initCategoryActive(), this.initProductReviewSection(), this.productCustomInformation(), this.iconZoomClickMobile()), (t.hasClass("template-blog") || t.hasClass("template-article")) && (this.initCollapseSidebarBlock(), this.initCategoryActive(), this.toggleSidebarMobile(), this.initBlogMasonry(), this.productBlockSilderSidebar(), this.productBlockSilderArticle()), t.hasClass("template-article") && this.articleGallery(), (t.hasClass("template-collection") || t.hasClass("template-search")) && (this.initCollapseSidebarBlock(), this.initCategoryActive(), this.toggleSidebarMobile(), this.productBlockSilderSidebar(), this.initInfiniteScrolling(), this.initQuickShopProductList()), t.hasClass("template-collection") && e(".collection-express-order").length && (this.toggleVariantsForExpressOrder(), this.initExpressOrderAddToCart()), e("[data-lookbook-icon]").length) {
                const e = [...document.querySelectorAll("[data-lookbook-icon]")];
                e.forEach(((e, t) => {
                    this.getProductDataForLookbook(e)
                }));
                const t = e.map((e => {
                    const t = e.closest(".articleGallery-block") || e.closest(".slideshow-wrapper") || e.closest(".collection-lookbook") || e.closest(".large-lookbook-banner");
                    return null != t ? t.id : null
                })).filter((e => null != e));
                new Set(t).forEach((e => {
                    const t = document.getElementById(`${e}`).querySelector("[data-style]"),
                        a = t?.dataset.showLookbookDefault,
                        o = parseInt(t?.dataset.style) || 3;
                    1 === o ? this.addEventLookbookModal(e) : 2 === o ? this.addEventLookbookModalStyle2(e, a) : this.addEventLookbookModalStyle3(e), this.addEventLookbookModalMobile(e)
                }))
            }
            if (e("[data-drag-container]").length) {
                const e = document.querySelectorAll("[data-drag-container]");
                if (0 === e.length) return;
                e.forEach((e => {
                    this.initDragToScroll(e)
                }))
            }
            o.on("resize", (() => {
                this.headerSidebarSearch()
            }))
        },
        checkNeedToConvertCurrency: function() {
            return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency || window.show_auto_currency
        },
        loaderScript: function() {
            var t = function() {
                var t = e("[data-loader-script]");
                t.length > 0 && t.each(((t, a) => {
                    var o = e(a),
                        n = o.data("loader-script"),
                        s = a.getBoundingClientRect().top;
                    o.hasClass("is-load") || s < window.innerHeight + 100 && (i.buildScript(n), e('[data-loader-script="' + n + '"]').addClass("is-load"))
                }))
            };
            t(), window.addEventListener("scroll", t)
        },
        buildScript: function(e) {
            var t = document.createElement("script");
            t.src = e, document.body.appendChild(t)
        },
        loaderProductBlock: function() {
            i.buildProductBlock()
        },
        buildProductBlock: function() {
            a.ajaxStart((() => {
                !0
            })), a.ajaxStop((() => {
                !1
            }));
            var t = e("[data-product-block]"),
                o = function() {
                    t.each(((t, a) => {
                        var o = a.getBoundingClientRect().top,
                            n = e(a);
                        if (!n.hasClass("ajax-loaded") && o < window.innerHeight) {
                            var s = n.data("collection"),
                                r = n.data("layout"),
                                l = n.data("limit"),
                                d = n.data("image-ratio"),
                                c = n.data("swipe"),
                                p = n.attr("sectionId");
                            hasCountdown = n.attr("hasCountdown"), null != s && null != s ? e.ajax({
                                type: "get",
                                url: window.routes.root + "/collections/" + s,
                                cache: !1,
                                data: {
                                    view: "ajax_product_block",
                                    constraint: "limit=" + l + "+layout=" + r + "+sectionId=" + p + "+imageRatio=" + d + "+swipe=" + c + "+hasCountdown=" + hasCountdown
                                },
                                beforeSend: function() {
                                    n.addClass("ajax-loaded")
                                },
                                success: function(e) {
                                    "" != s && ("grid" == r ? n.find(".products-grid").html(e) : "slider" == r ? n.find(".products-carousel").html(e) : "scroll" == r && n.find(".products-flex").html(e))
                                },
                                complete: function() {
                                    if ("slider" == r && i.productBlockSilder(n), "scroll" == r) {
                                        "true" === n.find("[data-enable-hover]").attr("data-enable-hover") && i.productBlockScroller(n)
                                    }
                                    if (window.compare.show) {
                                        var t = e("a[data-compare-link]");
                                        i.setLocalStorageProductForCompare(t)
                                    }
                                    if (i.swapHoverVideoProductCard(), window.wishlist.show && i.setLocalStorageProductForWishlist(), i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format"), window.review.show && e(".shopify-product-reviews-badge").length > 0) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                                }
                            }) : (n.addClass("ajax-loaded"), "slider" == r && i.productBlockSilder(n), i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format"))
                        }
                    }))
                };
            o(), window.addEventListener("scroll", o)
        },
        loaderRecommendationsBlock: function() {
            i.buildRecommendationBlock()
        },
        scrollToReview: function() {
            var t = e(".productView-tab");
            t.length && a.on("click", ".productView-details .halo-productReview", (a => {
                a.preventDefault(), e("body,html").animate({
                    scrollTop: t.offset().top
                }, 1e3);
                var o = t.find('[href="#tab-review"]'),
                    i = t.find('[href="#tab-customer-reviews"]'),
                    n = t.find('[href="#tab-review-mobile"]'),
                    s = t.find('[href="#tab-customer-reviews-mobile"]');
                o.hasClass("is-open") && n.hasClass("is-open") && i.hasClass("is-open") && s.hasClass("is-open") || (o[0]?.click(), n[0]?.click(), i[0]?.click(), s[0]?.click())
            }))
        },
        closeAnnouncementBar: function() {
            var t = e(".announcement-bar"),
                a = t.find("[data-close-announcement]");
            "closed" == e.cookie("announcement") ? t.remove() : (t.css("opacity", 1), t.css("visibility", "visible")), a.off("click.closeAnnouncementBar").on("click.closeAnnouncementBar", (function(a) {
                a.preventDefault(), a.stopPropagation(), t.remove(), e.cookie("announcement", "closed", {
                    expires: 1,
                    path: "/"
                })
            }))
        },
        sliderAnnouncementBar: function() {
            var t = e("[data-announcement-bar]");
            t.find(".announcement-bar__message").length > 1 && (t.hasClass("slick-initialized") || t.slick({
                infinite: !0,
                vertical: !0,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: !1,
                arrows: t.data("arrows"),
                autoplay: !0,
                autoplaySpeed: 3e3,
                nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
                prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>'
            }))
        },
        headerMasonry: function() {
            e(".menu-dropdown__wrapper [data-masonry]").masonry({
                columnWidth: ".grid-sizer",
                itemSelector: "[data-gridItem]"
            })
        },
        initLiveChat: function() {
            e(".live-wrapper-icon").on("click", (function(t) {
                e(this).parent().toggleClass("active")
            })), t.on("click", (function(t) {
                e(".live_help").hasClass("active") && 0 === e(event.target).closest(".live_help").length && (t.preventDefault(), e(".live_help").removeClass("active"))
            }))
        },
        headerdropdownCurrency: function() {
            if (e(".header-language_currency").length) {
                var t = e(".dropdown-currency");
                e(document).on("click", ".header-language_currency .halo-top-currency .currency-dropdown", (function(e) {
                    t.is(e.target) || 0 != t.has(e.target).length || t.toggleClass("show")
                })), e(document).on("click", ".header-language_currency .halo-top-currency .dropdown-menu .dropdown-item", (function(e) {
                    t.removeClass("show")
                })), e(document).on("click", (function(a) {
                    t.hasClass("show") && 0 === e(a.target).closest(".halo-top-currency").length && t.removeClass("show")
                })), (e(".header").hasClass("header-03") || e(".header").hasClass("header-04") || e(".header").hasClass("header-05") || e(".header").hasClass("header-06") || e(".header").hasClass("header-07") || e(".header").hasClass("header-08")) && (e(document).on("click", ".header-language_currency", (function(t) {
                    e(".header").hasClass("header-06") || e(".header").hasClass("header-08") ? e(".top-language-currency").is(t.target) || 0 != e(".top-language-currency").has(t.target).length || e(".top-language-currency").toggleClass("show") : e(".top-language-currency").is(t.target) || e(".top-language-currency").toggleClass("show")
                })), e(document).on("click", (function(t) {
                    e(".header-language_currency").is(t.target) || 0 != e(".header-language_currency").has(t.target).length || e(".top-language-currency").hasClass("show") && 0 === e(t.target).closest(".top-language-currency").length && 0 === e(t.target).closest(".header-language_currency").length && e(".top-language-currency").removeClass("show")
                })))
            }
        },
        headerdropdownLanguage: function() {
            e(".header-language_currency").length && (e(document).on("click", ".header-language_currency .halo-top-language", (function(t) {
                e(".dropdown-language").toggleClass("show")
            })), e(document).on("click", ".header-language_currency .halo-top-language .dropdown-menu .dropdown-item", (function(t) {
                e(".dropdown-language").removeClass("show")
            })), e(document).on("click", (function(t) {
                e(".dropdown-language").hasClass("show") && 0 === e(t.target).closest(".halo-top-language").length && e(".dropdown-language").removeClass("show")
            })))
        },
        headerSidebarSearch: function() {
            var t = e(".header-top .header__search .search_details"),
                a = e("#search-form-mobile .halo-sidebar-wrapper .search_details"),
                o = e(".header-top .header__search"),
                i = e("#search-form-mobile .halo-sidebar-wrapper"),
                n = e(".search_details");
        
            // Condition Remove -> Mobile behavior will work for all screen sizes
            if (e(".header").hasClass("header-01")) {
                t.appendTo(i);
            }
            n.attr("open", "true");
        
            // Search open function
            e("[data-search-mobile]").on("click", (t => {
                t.preventDefault();
                e("body").addClass("open_search_mobile"); // Mobile search open class
            }));
        
            // Search close function
            e("[data-search-close-sidebar], .background-overlay").on("click", (t => {
                t.preventDefault();
                e("body").removeClass("open_search_mobile"); // Mobile search close
            }));
        
            // Remove desktop-only behavior
            n.removeAttr("open");
            e(document).on("click", (t => {
                if (e("body").hasClass("open_search") && 0 === e(t.target).closest(".header__search").length) {
                    e("body").removeClass("open_search");
                    e(".search_details").removeAttr("open");
                }
            }));
        
            e(".search-modal__close-button").on("click", (t => {
                e(".search_details").removeAttr("open");
            }));
        
            // Keep desktop search behavior if needed
            if (e(".header").hasClass("header-02")) {
                n.attr("open", "true");
        
                e("[data-search-desktop]").on("click", (t => {
                    t.preventDefault();
                    e("body").addClass("open_search_desktop"); // Desktop search open
                }));
        
                e("[data-search-close-popup], .background-overlay").on("click", (t => {
                    t.preventDefault();
                    e("body").removeClass("open_search_desktop"); // Desktop search close
                }));
            }
        },
        
        headerStickySearchForm: function() {
            var t = "[data-search-sticky-form]";
            e(window).width() > 1025 && (e(document).off("click.toggleSearch", t).on("click.toggleSearch", t, (function(t) {
                t.preventDefault(), t.stopPropagation(), e("body").addClass("sticky-search-open"), e(".search_details").attr("open", "true")
            })), e(document).off("click.hideSearch").on("click.hideSearch", (function(t) {
                var a = e(".search-modal__form"),
                    o = e(".quickSearchResultsWrap");
                !e("body").hasClass("sticky-search-open") || a.has(t.target).length || o.has(t.target).length || (e("body").removeClass("sticky-search-open"), e(".search_details").removeAttr("open"))
            })))
        },
        menuSidebarMobile: function() {
            var a = e(".mobileMenu-toggle"),
                o = e(".halo-sidebar-close, .background-overlay");
            a.off("click.toggleCurrencyLanguage").on("click.toggleCurrencyLanguage", (() => {
                t.addClass("menu_open"), "default" == window.mobile_menu && (e("#navigation-mobile .site-nav-mobile.nav .header__inline-menu").length || e(".header .header__inline-menu").appendTo("#navigation-mobile .site-nav-mobile.nav")), e("#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text").length || e(".header-top--wrapper .header-top--right .free-shipping-text").appendTo("#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"), e("#navigation-mobile .site-nav-mobile.nav-account .customer-service-text").length || e(".header-top--wrapper .header-top--right .customer-service-text").appendTo("#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"), e("#navigation-mobile .site-nav-mobile.nav-account .header__location").length || e(".header-top--wrapper .header-top--right .header__location").appendTo("#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"), e("#navigation-mobile .top-language-currency").length || (e(".header").hasClass("header-03") ? e(".header .header-bottom-right .top-language-currency").appendTo("#navigation-mobile .site-nav-mobile.nav-currency-language") : e(".header").hasClass("header-05") ? e(".header .header-top--left .top-language-currency").appendTo("#navigation-mobile .site-nav-mobile.nav-currency-language") : e(".header .header-language_currency .top-language-currency").appendTo("#navigation-mobile .site-nav-mobile.nav-currency-language")), i.productMenuSlider()
            })), o.off("click.toggleCloseCurrencyLanguage").on("click.toggleCloseCurrencyLanguage", (() => {
                t.removeClass("menu_open"), e("#navigation-mobile").off("transitionend.toggleCloseMenu").on("transitionend.toggleCloseMenu", (() => {
                    t.hasClass("menu_open") || (e(".header .header__inline-menu").length || (e(".header").hasClass("header-03") || e(".header").hasClass("header-04") || e(".header").hasClass("header-07") || e(".header").hasClass("header-08") ? e("#navigation-mobile .site-nav-mobile.nav .header__inline-menu").appendTo(".header .header-bottom--wrapper .header-bottom-left") : e("#navigation-mobile .site-nav-mobile.nav .header__inline-menu").appendTo(".header .header-bottom--wrapper")), e(".header-top--wrapper .header-top--right .free-shipping-text").length || e(".header-04").hasClass("style_2") || e("#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text").insertBefore(".header-top--wrapper .header-top--right .header__group"), e(".header-top--wrapper .header-top--right .header__location").length || e("#navigation-mobile .site-nav-mobile.nav-account .header__location").insertBefore(".header-top--wrapper .header-top--right .header__group"), e(".header-top--wrapper .header-top--right .customer-service-text").length || (e(".header").hasClass("header-03") ? e("#navigation-mobile .site-nav-mobile.nav-account .customer-service-text").insertBefore(".header-top--wrapper .header-top--right .header__group .header__icon--wishlist") : e("#navigation-mobile .site-nav-mobile.nav-account .customer-service-text").insertBefore(".header-top--wrapper .header-top--right .top-language-currency")), e(".header-language_currency .top-language-currency").length || (e(".header").hasClass("header-03") || e(".header").hasClass("header-04") ? e("#navigation-mobile .site-nav-mobile .top-language-currency").appendTo(".header .header-bottom--wrapper .header-bottom-right .header-language_currency") : e(".header").hasClass("header-05") ? e("#navigation-mobile .site-nav-mobile .top-language-currency").appendTo(".header .header-top--wrapper .header-top--left .header-language_currency") : e("#navigation-mobile .site-nav-mobile .top-language-currency").insertBefore(".header .header-language_currency .header__search")))
                }))
            }))
        },
        menuSidebarMobileToggle: function() {
            t.on("click", ".site-nav-mobile .list-menu .menu_mobile_link", (function(t) {
                if (!t.currentTarget.classList.contains("list-menu__item--end")) {
                    t.preventDefault(), t.stopPropagation();
                    var a = e(this),
                        o = a.parent(),
                        i = a.parent().find("ul.list-menu--disclosure-1");
                    o.removeClass("is-hidden").addClass("is-open").removeClass("d-none"), i.off("transitionend.toggleMenuLink1").on("transitionend.toggleMenuLink1", (() => {
                        !o.hasClass("is-open") || o.hasClass("is-hidden") || o.hasClass("d-none") || (o.addClass("d-none"), o.siblings().removeClass("is-open").addClass("is-hidden").removeClass("d-none"))
                    }))
                }
            })), t.on("click", ".site-nav-mobile .list-menu .menu_mobile_link_2", (function(t) {
                t.preventDefault(), t.stopPropagation();
                var a = e(this),
                    o = (a = e(this)).parent().parent(),
                    i = a.parent().find("ul.list-menu--disclosure-2"),
                    n = a.parent().parent().parent().parent().parent().parent();
                o.removeClass("is-hidden").addClass("is-open").removeClass("d-none"), i.off("transitionend.toggleMenuLink2").on("transitionend.toggleMenuLink2", (() => {
                    !o.hasClass("is-open") || o.hasClass("is-hidden") || o.hasClass("d-none") || (o.addClass("d-none"), o.siblings().removeClass("is-open").addClass("is-hidden").removeClass("d-none"), n.animate({
                        scrollTop: 0
                    }, 0))
                })), (e(".menu-dropdown").hasClass("megamenu_style_4") || e(".menu-dropdown").hasClass("megamenu_style_1")) && a.parents(".menu-dropdown").animate({
                    scrollTop: 0
                }, 0), a.parents(".menu-dropdown").addClass("is-overflow")
            })), t.on("click", ".nav-title-mobile", (function(t) {
                t.preventDefault(), t.stopPropagation();
                var a = e(this),
                    o = a.parent().parent().parent().parent(".is-open"),
                    i = a.parent().parent().parent(".is-open"),
                    n = a.parent().parent(".is-open");
                o.siblings().removeClass("is-hidden"), o.removeClass("is-open").removeClass("d-none"), i.siblings().removeClass("is-hidden"), i.removeClass("is-open").removeClass("d-none"), n.siblings().removeClass("is-hidden"), n.removeClass("is-open").removeClass("d-none"), e(".menu-dropdown").removeClass("is-overflow")
            })), "default" != window.mobile_menu && a.on("click", "[data-mobile-menu-tab]", (e => {
                e.preventDefault(), e.stopPropagation();
                var t = e.currentTarget.closest("li"),
                    a = e.currentTarget.dataset.target;
                t.classList.contains("is-active") || document.querySelector("[data-navigation-tab-mobile]").querySelectorAll("li").forEach((e => {
                    e != t ? e.classList.remove("is-active") : (e.classList.add("is-active"), document.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((e => {
                        e.getAttribute("id") == a ? (e.classList.remove("is-hidden"), e.classList.add("is-visible")) : (e.classList.remove("is-visible"), e.classList.add("is-hidden"))
                    })))
                }))
            }))
        },
        initMultiTab: function() {
            if (e("[data-menu-tab]").length > 0) {
                a.on("click", "[data-menu-tab] li", (t => {
                    var a = e(t.currentTarget).data("load-page");
                    e(t.currentTarget).attr("href");
                    e.cookie("page-url", a, {
                        expires: 1,
                        path: "/"
                    })
                }));
                var t, o, i = e("[canonical-shop-url]").attr("canonical-shop-url"),
                    n = e.cookie("page-url");
                if (document.URL != i) {
                    null != n ? (t = e(`[data-load-page="${n}"]`), o = e(`[data-load-logo-page="${n}"]`)) : (t = e("[data-load-page].is-active"), o = e("[data-load-logo-page].first"));
                    var s = t.closest("[data-menu-tab]");
                    t.addClass("is-active"), s.find("[data-load-page]").not(t).removeClass("is-active"), o.addClass("is-active"), o.siblings().removeClass("is-active")
                }
                var r = e("[data-menu-tab] li.is-active").data("load-page");
                window.routes.root
            } else window.routes.root
        },
        initMultiTabMobile: function() {
            if ("custom" == window.mobile_menu) {
                var t = !1,
                    a = e('[data-section-type="menu"]'),
                    i = e("[data-navigation-mobile]"),
                    n = e("[data-navigation-tab-mobile]");
                document.body.addEventListener("touchstart", (() => {
                    if (0 == t) {
                        t = !0;
                        const e = document.createElement("div"),
                            o = document.createElement("ul");
                        Object.assign(o, {
                            className: "menu-tab list-unstyled"
                        }), o.setAttribute("role", "menu"), a.each(((t, a) => {
                            var o = a.querySelector("template").content.firstElementChild.cloneNode(!0);
                            0 == t ? o.classList.add("is-visible") : o.classList.add("is-hidden"), e.appendChild(o)
                        })), e.querySelectorAll('[id^="MenuMobileListSection-"]').forEach(((e, t) => {
                            var a = e.dataset.heading,
                                i = e.getAttribute("id"),
                                n = document.createElement("li");
                            Object.assign(n, {
                                className: "item"
                            }), n.setAttribute("role", "menuitem"), 0 == t && n.classList.add("is-active"), n.innerHTML = `<a class="link" href="#" data-mobile-menu-tab data-target="${i}">${a}</a>`, o.appendChild(n)
                        })), n.html(o), i.html(e.innerHTML)
                    }
                }), !1)
            }
        },
        clickedActiveProductTabs: function() {
            var t = function() {
                e("[data-product-tab-block]").each((function(t, a) {
                    var o = a.getBoundingClientRect().top,
                        n = e(a),
                        s = e(this),
                        r = s.find(".list-product-tabs"),
                        l = r.find("[data-product-tabTop]"),
                        d = s.find("[data-product-TabContent]"),
                        c = s.data("limit"),
                        p = r.find(".tab-links.active"),
                        u = s.find(".product-tabs-content .tab-content.active");
                    n.hasClass("ajax-loaded") || o < window.innerHeight && i.doAjaxProductTabs(p.data("href"), u.find(".loading"), u.find(".products-load"), s.attr("sectionid"), c, s), l.off("click").on("click", (function(t) {
                        if (t.preventDefault(), t.stopPropagation(), !e(this).hasClass("active") && !e(this).hasClass("active")) {
                            var a = e(this),
                                o = e(a.data("target"));
                            l.removeClass("active"), d.removeClass("active"), o.hasClass("loaded") || i.doAjaxProductTabs(a.data("href"), o.find(".loading"), o.find(".products-load"), s.attr("sectionid"), c), a.addClass("active"), o.addClass("active"), o.find(".slick-slider").slick("refresh")
                        }
                    }))
                }))
            };
            t(), window.addEventListener("scroll", t)
        },
        doAjaxProductTabs: function(t, a, o, n, s, r) {
            e.ajax({
                type: "get",
                url: t,
                data: {
                    constraint: `sectionId=${t}+limit=${s}`
                },
                beforeSend: function() {
                    a.text("Loading... please wait"), null != r && r.addClass("ajax-loaded")
                },
                success: function(n) {
                    a.hide(), "?view=ajax_product_block" == t ? (a.text("Please link to collections").show(), o.parent().addClass("loaded")) : (o.html(n), o.parent().addClass("loaded"), window.wishlist.show && i.setLocalStorageProductForWishlist(), i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format"))
                },
                complete: function() {
                    if (o.hasClass("products-carousel") && i.productBlockSilder(o.parent()), window.review.show && e(".shopify-product-reviews-badge").length > 0) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                },
                error: function(e, t) {
                    a.text("Sorry, there are no products in this collection").show()
                }
            })
        },
        addEventLookbookModal: function(o) {
            if (window.innerWidth <= 1024) return;
            const n = document.getElementById(`${o}`);
            e(n).off("click.addEvenLookbookModal touchstart.addEvenLookbookModal", "[data-lookbook-icon]").on("click.addEvenLookbookModal touchstart.addEvenLookbookModal", "[data-lookbook-icon]", (function(o) {
                o.preventDefault(), o.stopPropagation();
                var s = e(this).data("handle"),
                    r = e(this);
                const l = o.currentTarget;
                l.classList.add("active"), i.doAjaxAddLookbookModal(s, r), a.on("click", (a => {
                    if (t.hasClass("popup-lookbook-product-style-1") && 0 == e(a.target).closest("[data-lookbook-popup].style-1").length) return e(".halo-lookbook-popup.style-1").fadeOut(250), t.removeClass("popup-lookbook-product-style-1"), e(n).find("[data-lookbook-icon].active").each((function() {
                        e(this).removeClass("active")
                    })), !1
                })), e(l).on("click", (() => {
                    if (t.hasClass("popup-lookbook-product-style-1")) return e(".halo-lookbook-popup.style-1").fadeOut(250), t.removeClass("popup-lookbook-product-style-1"), e(n).find("[data-lookbook-icon].active").each((function() {
                        e(this).removeClass("active")
                    })), !1
                }))
            }))
        },
        getProductDataForLookbook(t) {
            const a = t.dataset.handle;
            e.ajax({
                type: "get",
                dataType: "json",
                url: window.routes.root + "/products/" + a + "?view=ajax_card",
                success: function(e) {
                    const o = e.product;
                    let i, n, s, r, l, d;
                    o.variants.length > 0 ? (i = o.title, n = `${o.variants[0].price}`, s = `${o.variants[0].compare_at_price}`, r = `${window.routes.root}/products/${a}`, l = o.vendor, d = o.image.src) : (i = o.title, n = `${o.price}`, s = `${o.compare_at_price}`, r = `${window.routes.root}/products/${a}`, l = o.vendor, d = o.image.src), t.dataset.title = i, t.dataset.price = n, t.dataset.priceCompare = s, t.dataset.link = r, t.dataset.vendor = l, t.dataset.image = d, t.classList.add("data-fetched")
                },
                complete: function() {}
            })
        },
        createFixedLookbook: function(t, a, o) {
            const i = t.dataset.handle,
                n = t.closest("[data-lookbook-item-container]"),
                s = t.offsetLeft;
            let r = 100 * (t.offsetTop - 50) / n.getBoundingClientRect().height,
                l = 100 * (s - 170) / n.getBoundingClientRect().width,
                d = !1;
            l < 0 && (l *= -1, d = !0);
            const c = document.createElement("div");
            c.classList.add("halo-lookbook-popup", "style-2", "fixed"), c.dataset.lookbookPopup = "";
            const p = document.createElement("div");
            p.classList.add("halo-popup-wrapper", "style-2", "fixed");
            const u = document.createElement("div");
            u.classList.add("halo-popup-content", "lookbook-content", "custom-scrollbar"), p.appendChild(u), c.appendChild(p), a && p.style.setProperty("--lookbook-background-color", a), o && p.style.setProperty("--lookbook-text-color", o);
            u.innerHTML = '   <div class="product-item style-2">\n                        <div class="card style-2"">\n                            <div class="card-information">\n                                <div class="card-information__wrapper text-center">\n                                    <a class="card-title link-underline card-title-ellipsis" href="javascript:void(0)">\n                                        <span class="text">\n                                            <span style="opacity: 0;">Lorem Ipsum Commopolis</span>\n                                        </span>\n                                    </a>\n                                    <div class="card-price">\n                                        <div class="price  price--on-sale">\n                                            <span class="money" style="opacity: 0;">Lorem Ipsum</span>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div> \n                ', c.style.left = `${l}%`, c.style.top = `${r}%`, d && c.classList.add("swapped");
            const h = t.dataset.title,
                m = `${Symbol}${t.dataset.price}`,
                w = `${window.routes.root}/products/${i}`;
            if (h && m) {
                const t = c.querySelector(".halo-popup-wrapper.style-2 .lookbook-content .card-title .text");
                t.innerHTML = h, t.setAttribute("href", w);
                const a = c.querySelector(".halo-popup-wrapper.style-2 .lookbook-content .card-price .price .money");
                a.innerHTML = m, a.style.opacity = "1";
                const o = c.querySelector(".halo-popup-wrapper.style-2");
                e(o).off("click").on("click", (() => {
                    window.location.href = w
                })), n.appendChild(c), setTimeout((() => {
                    c.classList.add("visible"), Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format")
                }), 10)
            }
        },
        createLookbookModalForSeperateDot: function(t, a, o) {
            const i = e(t).find(".glyphicon");
            var n, s, r = e(i).offset(),
                l = r.top,
                d = r.left,
                c = 220,
                p = i.innerWidth() + "px",
                u = c + "px";
            let h;
            window.innerWidth > 767 ? (d > 251 ? (s = "calc(" + d + "px - " + u + " + 35px)", h = !1) : (s = "calc(" + d + "px + " + p + " - 50px)", h = !0), n = l - 45 + "px") : (s = d, n = l - 10 + "px"), n = l - 45 + "px";
            const m = document.createElement("div");
            m.classList.add("halo-lookbook-popup", "style-2"), m.dataset.lookbookPopup = "";
            const w = document.createElement("div");
            w.classList.add("halo-popup-wrapper", "style-2");
            const f = document.createElement("div");
            f.classList.add("halo-popup-content", "lookbook-content", "custom-scrollbar"), w.appendChild(f), m.appendChild(w), a && w.style.setProperty("--lookbook-background-color", a), o && w.style.setProperty("--lookbook-text-color", o), h ? (e(w).css({
                "margin-left": "auto",
                "margin-right": "0"
            }), e(w).addClass("swapped")) : e(w).css({
                "margin-right": "auto",
                "margin-left": "0"
            });
            f.innerHTML = '   <div class="product-item style-2">\n                        <div class="card style-2"">\n                            <div class="card-information">\n                                <div class="card-information__wrapper text-center">\n                                    <a class="card-title link-underline card-title-ellipsis" href="javascript:void(0)">\n                                        <span class="text">\n                                            <span style="opacity: 0;">Lorem Ipsum Commopolis</span>\n                                        </span>\n                                    </a>\n                                    <div class="card-price">\n                                        <div class="price  price--on-sale">\n                                            <span class="money" style="opacity: 0;">Lorem Ipsum</span>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div> \n                ', m.style.left = s, m.style.top = n;
            const g = t.dataset.title,
                v = `${window.currencySymbol}${t.dataset.price}`,
                k = `${window.routes.root}/products/${t.dataset.handle}`;
            t.dataset.image;
            if (g && v) {
                const t = m.querySelector(".halo-popup-wrapper.style-2 .lookbook-content .card-title-ellipsis .text");
                t.innerHTML = g, t.setAttribute("href", k);
                const a = m.querySelector(".halo-popup-wrapper.style-2 .lookbook-content .card-price .price .money");
                a.innerHTML = v, a.style.opacity = "1";
                const o = m.querySelector(".halo-popup-wrapper.style-2");
                e(o).off("click").on("click", (() => {
                    window.location.href = k
                })), document.body.appendChild(m), setTimeout((() => {
                    m.classList.add("visible"), Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format")
                }), 10), requestAnimationFrame((() => {}))
            }
            return m
        },
        addEventLookbookModalStyle2: function(t, a) {
            if (window.innerWidth <= 1024) return;
            const o = document.getElementById(`${t}`),
                n = o.querySelector("[data-show-lookbook-container]"),
                s = n.dataset.dotsEnabled,
                r = n.dataset.lookbookBackgroundColor,
                l = n.dataset.lookbookTextColor;
            if ("true" !== a)
                if ("true" === s) e(o).off("mouseenter.addEvenLookbookModal touchstart.addEvenLookbookModal", "[data-lookbook-icon]").on("mouseenter.addEvenLookbookModal touchstart.addEvenLookbookModal", "[data-lookbook-icon]", (function(t) {
                    t.preventDefault(), t.stopPropagation();
                    e(this).data("handle");
                    const a = e(this)[0],
                        o = i.createLookbookModalForSeperateDot(a, r, l);
                    document.body.style.cursor = "pointer", e(o).on("mouseleave", (function() {
                        return o.classList.remove("visible"), document.body.style.cursor = "auto", setTimeout((() => {
                            e(o).remove()
                        }), 350), !1
                    }))
                }));
                else {
                    let t;
                    o.querySelectorAll("[data-lookbook-item-container]").forEach((a => {
                        a.addEventListener("mouseenter", (() => {
                            const o = [...a.querySelectorAll("[data-lookbook-icon]")];
                            a.classList.contains("has-popup") || (a.classList.add("has-popup"), t = o.map((t => {
                                t.dataset.handle, e(t).find(".glyphicon");
                                return i.createLookbookModalForSeperateDot(t, r, l)
                            })))
                        })), a.addEventListener("mouseleave", (o => {
                            o.stopPropagation(), o.preventDefault();
                            t.some((e => {
                                const t = e.getBoundingClientRect();
                                return o.clientX >= t.left && o.clientX <= t.right && o.clientY >= t.top && o.clientY <= t.bottom
                            })) ? t.forEach((o => {
                                o.addEventListener("mouseleave", (o => {
                                    o.stopPropagation(), o.preventDefault();
                                    const i = a.getBoundingClientRect();
                                    o.clientX >= i.left && o.clientX <= i.right && o.clientY >= i.top && o.clientY <= i.bottom || (t.forEach((t => {
                                        t.classList.remove("visible"), setTimeout((() => {
                                            e(t).remove()
                                        }), 350)
                                    })), a.classList.remove("has-popup"))
                                }))
                            })) : (t.forEach((t => {
                                t.classList.remove("visible"), setTimeout((() => {
                                    e(t).remove()
                                }), 350)
                            })), a.classList.remove("has-popup"))
                        }))
                    }))
                }
            else {
                const e = o.querySelectorAll("[data-lookbook-icon]"),
                    t = setInterval((() => {
                        [...e].every((e => null != e.dataset.title)) && (clearInterval(t), e.forEach((e => {
                            e.style.visibility = "hidden", i.createFixedLookbook(e, r, l)
                        })))
                    }), 50)
            }
        },
        doAjaxAddLookbookModal: function(o, n) {
            var s, r, l = e(n).offset(),
                d = l.top,
                c = l.left,
                p = n.innerWidth(),
                u = e(".halo-lookbook-popup.style-1").innerWidth(),
                h = p + "px",
                m = u + "px";
            window.innerWidth > 767 ? (r = c > u + 31 ? "calc(" + c + "px - " + m + " - 20px)" : "calc(" + c + "px + " + h + " - 2px)", s = d - u / 2 + "px") : (r = 0, s = d + 10 + "px"), a.ajaxStop((() => {
                isAjaxLoading = !1
            }));
            e(".halo-lookbook-popup.style-1 .halo-popup-wrapper.style-1 .lookbook-content").html('   <div class="product-item">\n                    <div class="card">\n                        <div class="card-product">\n                            <div class="card-product__wrapper">\n                                <a class="card-media card-media--adapt media--hover-effect animated-loading" style="width: 100%; max-height: 226px;"></a>\n                            </div>\n                        </div>\n                        <div class="card-information">\n                            <div class="card-information__wrapper text-center">\n                                <div class="card-information__group card-information__group-2">\n                                    <div class="card-vendor animated-loading"">\n                                        <span style="opacity: 0;">Lorem Ipsum</span>\n                                    </div>\n                                </div>\n                                <a class="card-title link-underline card-title-ellipsis">\n                                    <span class="text animated-loading">\n                                        <span style="opacity: 0;">Lorem Ipsum Commopolis</span>\n                                    </span>\n                                </a>\n                                <div class="card-price animated-loading">\n                                    <div class="price  price--on-sale">\n                                        <span style="opacity: 0;">Lorem Ipsum</span>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div> \n            '), e(".halo-lookbook-popup.style-1").css({
                left: r,
                top: s
            }), t.addClass("popup-lookbook-product-style-1"), e(".halo-lookbook-popup.style-1").fadeIn(250), e.ajax({
                type: "get",
                url: window.routes.root + "/products/" + o + "?view=ajax_card",
                success: function(t) {
                    e(".halo-lookbook-popup.style-1 .halo-popup-wrapper.style-1 .lookbook-content").html(t)
                },
                complete: function() {
                    i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format")
                }
            })
        },
        addEventLookbookModalMobile: function(e) {
            if (window.innerWidth > 1024) return;
            const t = document.getElementById(`${e}`),
                a = t.querySelector("[data-show-lookbook-container]");
            let o;
            o = e.startsWith("collection-lookbook") ? "collection-lookbook" : e.startsWith("large-lookbook-banner") ? "large-lookbook-banner" : a.classList.contains("articleGallery-slider") ? "gallery" : "slideshow";
            const n = a.querySelectorAll("[data-lookbook-icon]"),
                s = "collection-lookbook" === o || "large-lookbook-banner" === o ? "true" : a.dataset.dotsMobileEnabled,
                r = document.querySelector("[data-lookbook-popup-mobile]"),
                l = document.querySelector("[data-lookbook-mobile-images-container]"),
                d = r.querySelector(".close-modal"),
                c = setInterval((() => {
                    if ([...n].every((e => null != e.dataset.title)))
                        if (clearInterval(c), "true" === s) "gallery" === o ? n.forEach((e => {
                            e.addEventListener("click", (e => {
                                i.handleLookbookModalIconMobileClick(e, !0)
                            }))
                        })) : t.querySelectorAll("[data-show-lookbook-container]").forEach((e => {
                            e.querySelectorAll("[data-lookbook-icon]").forEach((e => {
                                e.addEventListener("click", (e => {
                                    i.handleLookbookModalIconMobileClick(e, !0)
                                }))
                            }))
                        }));
                        else if ("gallery" === o) {
                        a.querySelectorAll("[data-fancybox]").length > 0 && a.querySelectorAll(".fancybox-disabled").forEach((e => {
                            delete e.dataset.fancybox, e.addEventListener("click", (e => {
                                i.handleLookbookModalIconMobileClick(e, !1)
                            }))
                        }))
                    } else t.querySelectorAll("[data-show-lookbook-container]").forEach((e => {
                        e.querySelector("[data-lookbook-item-container]").addEventListener("click", (e => {
                            i.handleLookbookModalIconMobileClick(e, !1)
                        }))
                    })), a.querySelectorAll("[data-lookbok-item-container]").forEach((e => {
                        e.addEventListener("click", (e => {
                            i.handleLookbookModalIconMobileClick(e, !1)
                        }))
                    }))
                }), 50);
            r.addEventListener("click", (e => {
                null == e.target.closest("[data-lookbook-popup-mobile-wrapper]") && (document.body.classList.remove("mobile-popup-active"), r.addEventListener("transitionend", (() => {
                    i.mobileLookbookModalSlideDown(l)
                })))
            })), d.addEventListener("click", (() => {
                document.body.classList.remove("mobile-popup-active"), r.addEventListener("transitionend", (() => {
                    this.mobileLookbookModalSlideDown(l)
                }))
            }))
        },
        handleLookbookModalIconMobileClick: function(e, t) {
            e.preventDefault(), e.stopPropagation();
            const a = e.target.closest("[data-lookbook-item-container]").querySelectorAll("[data-lookbook-icon]"),
                o = e.target.closest("[data-lookbook-icon]")?.dataset.handle;
            a.forEach(((e, n) => {
                i.createLookbookModalMobile(e, o, t, n, a.length)
            }))
        },
        createLookbookModalMobile: function(t, a = null, o, i, n) {
            const s = t.dataset.handle,
                r = (document.querySelector("[data-lookbook-popup-mobile]"), document.querySelector("[data-lookbook-mobile-images-container]")),
                l = t.closest("[data-show-lookbook-container]").dataset.showLookbookInfo || "true",
                d = document.createElement("div");
            d.classList.add("lookbook-mobile-item"), d.dataset.lookbookMobileItem = "true";
            const c = document.createElement("div");
            c.classList.add("img-box");
            const p = document.createElement("a");
            p.classList.add("lookbook-mobile-image-container");
            const u = document.createElement("img");
            p.appendChild(u), c.appendChild(p), d.appendChild(c);
            const h = document.createElement("a");
            h.classList.add("mobile-lookbook-title", "text-shorten");
            const m = document.createElement("div");
            m.classList.add("mobile-lookbook-price", "price");
            m.innerHTML = "<div class='regular-price price__regular'><div class='last-price price__last'><span class='price-item price-item--regular'><span class='money'></span></span></div> </div> <div class='sale-price price__sale'><div class='price-at-compare price__compare'><span class='price-item price-item--regular'><span class='money'></span></span></div> <div class='last-price price__last'><span class='price-item price-item--sale'><span class='money'></span></span></div></div>", d.appendChild(h), d.appendChild(m), d.dataset.handle = s;
            const w = t.dataset.title,
                f = t.dataset.price,
                g = t.dataset.priceCompare,
                v = `${window.routes.root}/products/${s}`,
                k = t.dataset.image;
            if (w && f && v && k) {
                if (e(p).attr("href", v), e(u).attr("src", k), e(u).on("load", (function() {
                        e(u).addClass("loaded")
                    })), "true" === l ? (h.innerHTML = w, h.href = v, m.querySelectorAll(".last-price .money").forEach((e => {
                        e.textContent = `${window.currencySymbol}${f}`
                    })), g ? (m.classList.add("price--on-sale"), m.querySelector(".price-at-compare .money").textContent = `${window.currencySymbol}${g}`, m.querySelector(".price-at-compare .money").style.marginRight = "10px", m.querySelector(".regular-price").style.display = "none") : m.querySelector(".sale-price").style.display = "none") : (e(h).remove(), e(m).remove()), r.appendChild(d), r.querySelectorAll("[data-lookbook-mobile-item]").length >= 2 ? window.innerWidth < 767 && (r.style.width = "max-content") : r.style.width = "100%", !document.body.classList.contains("mobile-popup-active") && i === n - 1) {
                    const e = [...r.querySelectorAll("img")];
                    let t = setInterval((() => {
                        e.every((e => e.classList.contains("loaded"))) && (clearInterval(t), this.mobileLookbookModalSlideUp())
                    }), 50)
                }
                if (o) {
                    const e = [...document.querySelectorAll("[data-lookbook-mobile-item]")].find((e => e.dataset.handle === a));
                    if (null == e) return;
                    document.querySelector("[data-lookbook-popup-mobile-wrapper]").addEventListener("transitionend", (() => {
                        e.scrollIntoView({
                            block: "nearest",
                            behavior: "smooth"
                        })
                    }))
                }
            }
        },
        mobileLookbookModalSlideUp: function() {
            Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format"), document.body.classList.add("mobile-popup-active")
        },
        mobileLookbookModalSlideDown: function(e) {
            if (!document.body.classList.contains("mobile-popup-active"))
                for (; e.firstChild;) e.removeChild(e.firstChild)
        },
        addEventLookbookModalStyle3: function(e) {
            if (window.innerWidth <= 1024) return;
            const t = document.querySelector(`#${e}`),
                a = [...t.querySelectorAll("[data-lookbook-icon]")],
                o = [...t.querySelectorAll("[data-lookbook-image]")],
                i = e => {
                    const t = e.querySelector(".lookbook-modal");
                    if (!t) return;
                    const a = e.dataset.title,
                        o = e.dataset.price,
                        i = e.dataset.priceCompare,
                        n = (e.dataset.vendor, e.dataset.link),
                        s = t.querySelector(".product-title"),
                        r = t.querySelector(".icon-wrapper");
                    n && (s.href = n, r.href = n);
                    const l = t.querySelector(".product-title .text");
                    a && (l.textContent = a);
                    const d = t.querySelector(".sale-price .price-at-compare .price-item .money"),
                        c = t.querySelectorAll(".product-price .last-price .price-item .money");
                    if (o && c.forEach((e => e.textContent = `${window.currencySymbol}${o}`)), i) {
                        const e = t.querySelector(".product-price");
                        d.textContent = `${window.currencySymbol}${i}`, t.querySelector(".regular-price .last-price").style.display = "none", e.classList.add("price--on-sale")
                    } else t.querySelector(".sale-price").style.display = "none"
                },
                n = e => {
                    const t = 2 == e.dataset.productsShowStyle,
                        a = e.querySelector("[data-show-all-lookbook]"),
                        o = e.querySelector("[data-lookbook-show-all-close]");
                    a?.addEventListener("click", (() => {
                        if (t) return e.classList.add("show-all-products");
                        e.classList.toggle("show-all")
                    })), o?.addEventListener("click", (() => {
                        e.classList.remove("show-all-products")
                    }))
                };
            let s = setInterval((() => {
                a.every((e => e.classList.contains("data-fetched"))) && (a.forEach(i), o.forEach(n), clearInterval(s))
            }), 10)
        },
        productBlockSilder: function(e) {
            var t = e.find(".products-carousel"),
                a = t.data("item-to-show"),
                o = t.data("item-dots"),
                i = t.data("item-arrows");
            t.length > 0 && t.not(".slick-initialized") && (t.slick({
                mobileFirst: !0,
                adaptiveHeight: !0,
                vertical: !1,
                infinite: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !1,
                dots: !0,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                responsive: [{
                    breakpoint: 1599,
                    settings: {
                        arrows: i,
                        dots: o,
                        get slidesToShow() {
                            return this.slidesToShow = null != a && "" !== a ? a : 1
                        }
                    }
                }, {
                    breakpoint: 1024,
                    settings: {
                        arrows: i,
                        dots: o,
                        get slidesToShow() {
                            return null != a && "" !== a ? 5 == a || 6 == a ? this.slidesToShow = a - 1 : t.parents(".collection-column-2").length ? this.slidesToShow = 2 : this.slidesToShow = a : this.slidesToShow = 1
                        }
                    }
                }, {
                    breakpoint: 991,
                    settings: {
                        get slidesToShow() {
                            return t.hasClass("has__banner_tab") || t.parents(".product-block-has__banner").length ? t.parents(".product-block-has__banner").length && t.parents(".product-block-has__banner").data("width-banner") > 40 ? this.slidesToShow = 2 : this.slidesToShow = 3 : t.parents(".collection-column-2").length ? this.slidesToShow = 2 : this.slidesToShow = 4
                        },
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        get slidesToShow() {
                            return t.hasClass("has__banner_tab") || t.parents(".product-block-has__banner").length ? this.slidesToShow = 2 : this.slidesToShow = 3
                        },
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 320,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }]
            }), e.hasClass("ajax-loaded"))
        },
        productBlockInfiniteScroll: function() {
            e("[data-product-block], [data-product-tab-block]").each(((t, a) => {
                var o = e(a),
                    n = o.find("[data-product-infinite]");
                n.length > 0 && n.find(".button").on("click", (t => {
                    var a = e(t.target);
                    if (!a.hasClass("view-all")) {
                        t.preventDefault(), t.stopPropagation(), a.addClass("is-loading");
                        var n = a.attr("data-collection"),
                            s = a.attr("data-limit"),
                            r = a.attr("data-swipe"),
                            l = a.attr("data-total"),
                            d = a.attr("data-image-ratio"),
                            c = a.attr("sectionId"),
                            p = parseInt(a.attr("data-page"));
                        i.doProductBlockInfiniteScroll(n, l, s, r, d, c, p, a, o)
                    }
                }))
            }))
        },
        doProductBlockInfiniteScroll: function(t, a, o, n, s, r, l, d, c) {
            e.ajax({
                type: "get",
                url: window.routes.root + "/collections/" + t,
                cache: !1,
                data: {
                    view: "ajax_product_block_load_more",
                    constraint: "limit=" + o + "+page=" + l + "+sectionId=" + r + "+imageRatio=" + s + "+swipe=" + n
                },
                beforeSend: function() {},
                success: function(i) {
                    c.find(".products-grid").append(i);
                    var n = c.find(".products-grid .product").length;
                    if (e(i).length == o && n < 50) {
                        var s = window.button_load_more.default;
                        d.removeClass("is-loading"), d.attr("data-page", l + 1), d.find("span").text(s)
                    } else if (a > 50) {
                        s = window.button_load_more.view_all;
                        d.find("span").text(s), d.removeClass("is-loading"), d.attr("href", window.routes.root + "/collections/" + t).addClass("view-all")
                    } else {
                        s = window.button_load_more.no_more;
                        d.find("span").text(s), d.removeClass("is-loading"), d.attr("disabled", "disabled")
                    }
                },
                complete: function() {
                    if (i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format"), window.review.show && e(".shopify-product-reviews-badge").length > 0) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                }
            })
        },
        productMenuSlider: function() {
            var t = e(".megamenu_style_5");
            t.length > 0 && t.each(((t, a) => {
                let o = e(a).find(".products-carousel"),
                    i = o.data("row");
                o.not(".slick-initialized") && o.slick({
                    mobileFirst: !0,
                    adaptiveHeight: !0,
                    vertical: !1,
                    infinite: !1,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: !1,
                    dots: !0,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 1500,
                        settings: {
                            slidesToShow: i,
                            slidesToScroll: 1,
                            dots: !1
                        }
                    }]
                })
            }))
        },
        buildRecommendationBlock: function() {
            if (null == document.querySelector("[data-recommendations-block]")) return;
            var t = document.querySelector("[data-recommendations-block]"),
                a = t.dataset.layout;
            swipe = t.dataset.swipe;
            new IntersectionObserver(((o, n) => {
                const s = t.querySelector(".wrapper-container");
                o[0].isIntersecting && ("" == t.innerHTML.trim() || s.classList.contains("product-recommendations-loading") || s.classList.contains("has-product")) && (s.classList.add("has-product"), fetch(t.dataset.url).then((e => e.text())).then((o => {
                    const n = document.createElement("div");
                    n.innerHTML = o;
                    const s = n.querySelector("[data-recommendations-block]");
                    if (s && s.innerHTML.trim().length) {
                        if (t.innerHTML = s.innerHTML, !e(t).find(".product-item").eq(0).data("json-product")) return e(t).remove();
                        "slider" == a ? i.productBlockSilder(e(t)) : 1 == swipe && console.log("ok"), e(t).find(".product-item").each((async (t, a) => {
                            var o = e(a),
                                n = o.data("product-id"),
                                s = o.data("json-product").handle;
                            await e.ajax({
                                type: "get",
                                url: window.routes.root + "/products/" + s + "?view=ajax_variant_quantity",
                                beforeSend: function() {},
                                success: function(e) {
                                    const t = (new DOMParser).parseFromString(e, "text/html"),
                                        a = JSON.parse(t.querySelector(`[data-quantity-product-id="${n}"]`).innerHTML);
                                    window[`quick_view_inven_array_${n}`] = a
                                },
                                error: function(t, a) {
                                    i.showWarning(e.parseJSON(t.responseText).description)
                                },
                                complete: function() {}
                            })
                        }));
                        const o = t.querySelectorAll(".media--loading-effect img");
                        if (this.observeImageLazyloaded(o), window.compare.show) {
                            var r = e("a[data-compare-link]");
                            i.setLocalStorageProductForCompare(r)
                        }
                        if (window.wishlist.show && i.setLocalStorageProductForWishlist(), window.review.show && e(".shopify-product-reviews-badge").length > 0) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                    }
                })).catch((e => {
                    console.error(e)
                })))
            }).bind(t), {
                rootMargin: "1000px"
            }).observe(t)
        },
        initVideoPopup: function() {
            e(".video-open-popup ").length && (e(".video-open-popup a").off("click").on("click", (function() {
                let a = e(this).attr("data-type"),
                    o = e(this).attr("data-src");
                const i = `<div class="fluid-width-video-wrapper" style="padding-top: ${e(this).attr("aspect_ratio")}">\n                                    ${"youtube"==a?`<iframe\n                                            id="player"\n                                            type="text/html"\n                                            width="100%"\n                                            frameborder="0"\n                                            webkitAllowFullScreen\n                                            mozallowfullscreen\n                                            allowFullScreen\n                                            src="https://www.youtube.com/embed/${o}?autoplay=1&mute=1">\n                                        </iframe>`:`<iframe \n                                            src="https://player.vimeo.com/video/${o}?autoplay=1&mute=1" \n                                            class="js-vimeo" \n                                            allow="autoplay; \n                                            encrypted-media" \n                                            webkitallowfullscreen \n                                            mozallowfullscreen \n                                            allowfullscreen">\n                                        </iframe>`}\n                                </div>`;
                e("[data-popup-video]").find(".halo-popup-content").html(i), t.addClass("video-show")
            })), e("[data-popup-video], [data-popup-video] .halo-popup-close, .background-overlay").on("click", (function(a) {
                let o = e("[data-popup-video] .halo-popup-content");
                o.is(a.target) || o.has(a.target).length || (t.removeClass("video-show"), e("[data-popup-video] iframe").remove())
            })))
        },
        swapHoverVideoProductCard: function() {
            window.innerWidth > 1200 && (e(".product-item .card").mouseenter((function() {
                var t = e(this).find("video"),
                    a = e(this).find("video").get(0);
                t.length > 0 && a.play()
            })), e(".product-item .card").mouseleave((function() {
                var t = e(this).find("video"),
                    a = e(this).find("video").get(0);
                t.length > 0 && a.pause()
            })))
        },
        initGlobalCheckbox: function() {
            a.on("change", ".global-checkbox--input", (t => {
                var a = t.target.getAttribute("data-target");
                t.target.checked ? e(a).attr("disabled", !1) : e(a).attr("disabled", !0)
            })), a.on("click", "[data-term-condition]", (e => {
                e.preventDefault(), e.stopPropagation(), t.addClass("term-condition-show")
            })), a.on("click", "[data-close-term-condition-popup]", (e => {
                e.preventDefault(), e.stopPropagation(), t.removeClass("term-condition-show")
            })), a.on("click", (a => {
                setTimeout((() => {
                    t.hasClass("cart-sidebar-show") && 0 === e(a.target).closest("[data-term-condition-popup]").length && t.removeClass("term-condition-show"), t.hasClass("term-condition-show") && 0 === e(a.target).closest("[data-term-condition-popup]").length && t.removeClass("term-condition-show")
                }), 10)
            }))
        },
        initColorSwatch: function() {
            e(".card .swatch-label.is-active").trigger("click"), a.on("click", ".card .swatch-label", (a => {
                var o = e(a.currentTarget),
                    n = o.attr("title").replace(/^\s+|\s+$/g, ""),
                    s = o.closest(".product-item"),
                    r = s.data("json-product"),
                    l = s.find(".card-title"),
                    d = s.find("[data-btn-addtocart]"),
                    c = o.data("variant-id"),
                    p = s.find("a").attr("href"),
                    u = o.data("with-one-option"),
                    h = o.data("variant-img"),
                    m = [];
                o.parents(".swatch").find(".swatch-label").removeClass("is-active"), o.addClass("is-active"), l.hasClass("card-title-change") ? t.hasClass("style_2_text_color_varriant") ? l.find("[data-change-title]").text(n) : l.find("[data-change-title]").text(" - " + n) : t.hasClass("style_2_text_color_varriant") ? l.addClass("card-title-change").append("<span data-change-title>" + n + "</span>") : l.addClass("card-title-change").append("<span data-change-title> - " + n + "</span>");
                const w = r.variants.find((e => e.id === c));
                if (w.compare_at_price > w.price) {
                    s.find(".price__sale .price-item--regular").html(Shopify.formatMoney(w.compare_at_price, window.money_format)), s.find(".price__sale .price-item--sale").html(Shopify.formatMoney(w.price, window.money_format));
                    const e = `-${Math.round(100*(w.compare_at_price-w.price)/w.compare_at_price)}%`;
                    s.find(".price__label_sale .label_sale").html(e)
                } else s.find(".price__regular .price-item").html(Shopify.formatMoney(w.price, window.money_format));
                if (s.find("a:not(.single-action):not(.number-showmore)").attr("href", p.split("?variant=")[0] + "?variant=" + c), null != u) {
                    var f = o.data("quantity");
                    s.find('[name="id"]').val(u), f > 0 ? window.notify_me.show ? d.removeClass("is-notify-me").addClass("is-visible") : d.removeClass("is-soldout").addClass("is-visible") : window.notify_me.show ? d.removeClass("is-visible").addClass("is-notify-me") : d.removeClass("is-visible").addClass("is-soldout"), d.hasClass("is-soldout") || d.hasClass("is-notify-me") ? d.hasClass("is-notify-me") ? d.text(window.notify_me.button) : d.text(window.variantStrings.soldOut).prop("disabled", !0) : d.text(window.variantStrings.addToCart).prop("disabled", !1)
                } else null != r && window.quick_shop.show && i.checkStatusSwatchQuickShop(s, r), s.find('.swatch-element[data-value="' + n + '"]').find(".single-label").trigger("click");
                if (null != r.media) m = r.media.filter(((e, t) => t.alt === n));
                if (m.length > 0) {
                    if (m.length > 1) var g = 2;
                    else g = m.length;
                    for (var v = 0; v < g; v++) s.find(".card-media img:eq(" + v + ")").attr("srcset", m[v].src)
                } else h && s.find(".card-media img:nth-child(1)").attr("srcset", h)
            })), a.on("click", ".item-swatch-more a", (t => {
                e(t.target).closest(".swatch").hasClass("show--more") ? (e(t.target).closest(".swatch").removeClass("show--more"), e(t.target).find("span:eq(0)").text("+")) : (e(t.target).closest(".swatch").addClass("show--more"), e(t.target).find("span:eq(0)").text("-"))
            }))
        },
        initQuickShop: function() {
            window.quick_shop.show && (a.on("click", "[data-quickshop-popup]", (n => {
                n.preventDefault(), n.stopPropagation();
                var s = e(n.target),
                    r = s.parents(".product-item"),
                    l = r.data("json-product"),
                    d = r.find(".variants-popup");
                if (r.hasClass("quickshop-popup-show")) i.initAddToCartQuickShop(s, d);
                else {
                    if (e(".product-item").removeClass("quickshop-popup-show"), t.hasClass("quick_shop_option_2")) {
                        var c = r.find(".card-media").outerHeight(!0),
                            p = d.find(".variants");
                        t.hasClass("product-card-layout-02") ? o.width() > 1024 ? (p.css("max-height", c - 114 + "px"), p.css("min-height", c - 114 + "px")) : (p.css("max-height", c - 70 + "px"), p.css("min-height", c - 70 + "px")) : t.hasClass("product-card-layout-04") ? o.width() > 1024 ? (p.css("max-height", c - 116 + "px"), p.css("min-height", c - 116 + "px")) : (p.css("max-height", c - 70 + "px"), p.css("min-height", c - 70 + "px")) : o.width() > 1024 ? (p.css("max-height", c - 74 + "px"), p.css("min-height", c - 74 + "px")) : (p.css("max-height", c - 20 + "px"), p.css("min-height", c - 20 + "px")), p[0].scrollHeight > p[0].clientHeight && p.addClass("scrollable"), e(".productListing").hasClass("productList") || i.appendProductQuickShopOption2(r)
                    } else if (t.hasClass("quick_shop_option_3")) {
                        const o = s.data("product-handle");
                        e(".productListing").hasClass("productList") || i.updateContentQuickshopOption3(o), a.on("click", "[data-close-quick-shop-popup]", (e => {
                            e.preventDefault(), e.stopPropagation(), t.removeClass("quickshop-popup-show")
                        })), a.off("click.quickShopOverlay").on("click.quickShopOverlay", (a => {
                            t.hasClass("quickshop-popup-show") && e(a.target).is(".background-overlay") && t.removeClass("quickshop-popup-show")
                        }))
                    }
                    if (t.hasClass("quick_shop_option_3") ? e(".productListing").hasClass("productList") && i.appendToListViewModal(r) : o.width() < 767 && e(".productListing").hasClass("productList") ? i.appendToListViewModal(r) : r.addClass("quickshop-popup-show"), r.find(".swatch-label.is-active").trigger("click"), i.checkStatusSwatchQuickShop(r, l), e(".card-swatch").hasClass("quick_shop_type_2") || e("productListing").hasClass("productList") && !e(".card-swatch").hasClass("quick_shop_type_3")) {
                        if (o.width() < 767)
                            if (e(".productListing").hasClass("productList")) d.find(".selector-wrapper").each(((t, a) => {
                                e(a).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find(".single-label").trigger("click")
                            }));
                            else e("#halo-card-mobile-popup .variants-popup").find(".selector-wrapper").each(((t, a) => {
                                e(a).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find(".single-label").trigger("click")
                            }));
                        else d.find(".selector-wrapper").each(((t, a) => {
                            e(a).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find(".single-label").trigger("click")
                        }));
                        e(".productListing").hasClass("productList") || t.addClass("quick_shop_popup_mobile")
                    } else d.find(".selector-wrapper:not(.option-color)").each(((t, a) => {
                        e(a).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find(".single-label").trigger("click")
                    }))
                }
            })), a.on("click", "[data-cancel-quickshop-popup]", (o => {
                o.preventDefault(), o.stopPropagation();
                var i = e(o.currentTarget).parents(".product-item"),
                    n = a.find("#halo-card-mobile-popup");
                i.removeClass("quickshop-popup-show"), a.find(".quickshop-popup-show").removeClass("quickshop-popup-show"), e(".card-swatch").hasClass("quick_shop_type_2") && (t.removeClass("quick_shop_popup_mobile"), n.removeClass("show"))
            })), a.on("click", (a => {
                0 === e(a.target).closest("[data-quickshop-popup]").length && 0 === e(a.target).closest(".variants-popup").length && 0 === e(a.target).closest(".card-swatch").length && 0 === e(a.target).closest("[data-warning-popup]").length && (e(".product-item").removeClass("quickshop-popup-show"), e(".card-swatch").hasClass("quick_shop_type_2") && t.removeClass("quick_shop_popup_mobile"))
            })), i.changeSwatchQuickShop())
        },
        appendToListViewModal: function(o) {
            const i = a.find("#list-view-popup"),
                n = o.clone();
            i.find(".halo-popup-content").empty(), i.find(".halo-popup-content").append(n);
            const s = i.find("[data-quickshop] .card-information .variants-popup form").eq("0"),
                r = s.attr("id") + "-mobile",
                l = s.find(".single-option"),
                d = s.find(".single-label"),
                c = (i.find(".card-product"), i.find(".variants-popup")),
                p = i.find("[data-btn-addtocart]");
            c.removeClass("card-list__hidden");
            let u = {
                selected1: !1,
                selected2: !1,
                selected3: !1
            };
            s.attr("id", r), p.attr("data-form-id", p.attr("data-form-id") + "-mobile"), l.each(((t, a) => {
                e(a).attr("id", e(a).attr("id") + "-mobile"), e(a).attr("name", e(a).attr("name") + "-mobile")
            })), d.each(((t, a) => {
                e(a).attr("for", e(a).attr("for") + "-mobile");
                const o = e(a).closest(".selector-wrapper");
                e(a).closest(".swatch-element").hasClass("available") && (o.hasClass("selector-wrapper-1") && !u.selected1 ? (u.selected1 = !0, e(a).trigger("click")) : o.hasClass("selector-wrapper-2") && !u.selected2 ? (u.selected2 = !0, e(a).trigger("click")) : o.hasClass("selector-wrapper-3") && !u.selected3 && (u.selected3 = !0, e(a).trigger("click")))
            })), t.addClass("quickshop-list-view-show"), e(".background-overlay").off("click.closeListViewModal").on("click.closeListViewModal", (() => {
                t.removeClass("quickshop-list-view-show")
            }))
        },
        changeSwatchQuickShop: function() {
            a.on("change", "[data-quickshop] .single-option", (a => {
                var n, s, r = e(a.target),
                    l = r.parents(".product-item"),
                    d = l.data("json-product"),
                    c = l.find(".option-color").data("option-position"),
                    p = r.closest("[data-option-index]").data("option-index"),
                    u = l.find(".swatch-element"),
                    h = r.val(),
                    m = l.find("[name=id]"),
                    w = l.find(".selector-wrapper-1").find("input:checked").val(),
                    f = l.find(".selector-wrapper-2").find("input:checked").val();
                l.find(".selector-wrapper-3").find("input:checked").val();
                switch (t.hasClass("quick_shop_option_2") && e(".productListing").hasClass("productList") ? w = l.find(".selector-wrapper-1").eq("1").find("input:checked").val() : e(".productListing").hasClass("productList") && o.width() < 767 ? (w = l.find(".selector-wrapper-1").eq("1").find("input:checked").val(), f = l.find('[data-option-index="1"]').eq("1").find("input:checked").val()) : w = l.find(".selector-wrapper-1").eq("0").find("input:checked").val(), null != d && (n = d.variants), u.removeClass("soldout"), u.find('input[type="radio"]').prop("disabled", !1), p) {
                    case 0:
                        if (null != (g = n.find((e => 1 == c ? e.option2 == h && e.option1 == f : 2 == c ? e.option3 == h && e.option1 == f : e.option1 == h && e.option2 == f)))) s = g;
                        else s = n.find((e => 1 == c ? e.option2 == h : 2 == c ? e.option3 == h : e.option1 == h));
                        break;
                    case 1:
                        if (null != (g = n.find((e => 1 == c ? e.option2 == w && e.option1 == h && e.option3 == f : 2 == c ? e.option3 == w && e.option1 == h && e.option2 == f : e.option1 == w && e.option2 == h && e.option3 == f)))) s = g;
                        else s = n.find((e => 1 == c ? e.option2 == w && e.option1 == h : 2 == c ? e.option3 == w && e.option1 == h : e.option1 == w && e.option2 == h));
                        break;
                    case 2:
                        var g;
                        null != (g = n.find((e => 1 == c ? e.option2 == w && e.option1 == f && e.option3 == h : 2 == c ? e.option3 == w && e.option1 == f && e.option2 == h : e.option1 == w && e.option2 == f && e.option3 == h))) && (s = g)
                }
                if (null != s) {
                    m.val(s.id);
                    var v = r.val();
                    r.parents(".selector-wrapper").find(".form-label span").text(v), s.available ? (l.find("[data-btn-addtocart]").removeClass("btn-unavailable"), l.find("[data-quickshop] quickshop-update-quantity").removeClass("disabled")) : (l.find("[data-btn-addtocart]").addClass("btn-unavailable"), l.find("[data-quickshop] quickshop-update-quantity").addClass("disabled")), i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format"), !t.hasClass("quick_shop_option_2") && !t.hasClass("quick_shop_option_3") && o.width(), i.checkStatusSwatchQuickShop(l, d)
                }
            }))
        },
        checkStatusSwatchQuickShop: function(a, i) {
            var n, s = a.find(".card-variant"),
                r = a.find("[data-option-index]"),
                l = a.find(".option-color").data("option-position"),
                d = a.find('[data-option-index="0"]').find("input:checked").val(),
                c = a.find('[data-option-index="1"]').find("input:checked").val(),
                p = a.find('[data-option-index="2"]').find("input:checked").val(),
                u = a.data("product-id");
            if (t.hasClass("quick_shop_option_2")) {
                var h = a.find(".card-media").outerHeight(!0);
                null != p ? t.hasClass("product-card-layout-01") ? h < 310 ? e("[data-quickshop]").addClass("active_option_3") : e("[data-quickshop]").removeClass("active_option_3") : h < 370 ? e("[data-quickshop]").addClass("active_option_3") : e("[data-quickshop]").removeClass("active_option_3") : o.width() > 1024 ? t.hasClass("product-card-layout-05") ? h < 350 && null != c ? e("[data-quickshop]").addClass("active_option_3") : e("[data-quickshop]").removeClass("active_option_3") : t.hasClass("product-card-layout-01") ? h < 310 && null != c ? e("[data-quickshop]").addClass("active_option_3") : e("[data-quickshop]").removeClass("active_option_3") : h < 370 && null != c ? e("[data-quickshop]").addClass("active_option_3") : e("[data-quickshop]").removeClass("active_option_3") : t.hasClass("product-card-layout-01") ? h < 310 ? null != d || null != c ? e("[data-quickshop]").removeClass("active_option_3") : e("[data-quickshop]").addClass("active_option_3") : e("[data-quickshop]").removeClass("active_option_3") : h < 370 ? null != d || null != c ? e("[data-quickshop]").removeClass("active_option_3") : e("[data-quickshop]").addClass("active_option_3") : e("[data-quickshop]").removeClass("active_option_3")
            }
            if (t.hasClass("quick_shop_option_2") && e(".productListing").hasClass("productList") ? d = a.find('[data-option-index="0"]').eq("1").find("input:checked").val() : e(".productListing").hasClass("productList") && o.width() < 767 ? (d = a.find('[data-option-index="0"]').eq("1").find("input:checked").val(), c = a.find('[data-option-index="1"]').eq("1").find("input:checked").val()) : d = a.find('[data-option-index="0"]').eq("0").find("input:checked").val(), null != i && (n = i.variants), r.each(((t, a) => {
                    var o = e(a).data("option-index"),
                        i = e(a).find(".swatch-element");
                    switch (o) {
                        case 0:
                            i.each(((t, a) => {
                                var o = e(a),
                                    i = o.data("value"),
                                    s = n.find((e => 1 == l ? e.option2 == i && e.available : 2 == l ? e.option3 == i && e.available : e.option1 == i && e.available)),
                                    r = n.find((e => 1 == l ? e.option2 == i : 2 == l ? e.option3 == i : e.option1 == i));
                                null == s ? null == r ? (o.removeClass("soldout available").addClass("unavailable"), o.find('input[type="radio"]').prop("checked", !1)) : (o.removeClass("unavailable available").addClass("soldout").find(".single-action").attr("data-variant-id", r.title), o.find('input[type="radio"]').prop("disabled", !1)) : (o.removeClass("soldout unavailable").addClass("available"), o.find('input[type="radio"]').prop("disabled", !1))
                            }));
                            break;
                        case 1:
                            i.each(((t, a) => {
                                var o = e(a),
                                    i = o.data("value"),
                                    s = n.find((e => 1 == l ? e.option2 == d && e.option1 == i && e.available : 2 == l ? e.option3 == d && e.option1 == i && e.available : e.option1 == d && e.option2 == i && e.available)),
                                    r = n.find((e => 1 == l ? e.option2 == d && e.option1 == i : 2 == l ? e.option3 == d && e.option1 == i : e.option1 == d && e.option2 == i));
                                null == s ? null == r ? (o.removeClass("soldout available").addClass("unavailable"), o.find('input[type="radio"]').prop("checked", !1)) : (o.removeClass("unavailable available").addClass("soldout").find(".single-action-selector").attr("data-variant-id", r.title), o.find('input[type="radio"]').prop("disabled", !1)) : (o.removeClass("soldout unavailable").addClass("available"), o.find('input[type="radio"]').prop("disabled", !1))
                            }));
                            break;
                        case 2:
                            i.each(((t, a) => {
                                var o = e(a),
                                    i = o.data("value"),
                                    s = n.find((e => 1 == l ? e.option2 == d && e.option1 == c && e.option3 == i && e.available : 2 == l ? e.option3 == d && e.option1 == c && e.option2 == i && e.available : e.option1 == d && e.option2 == c && e.option3 == i && e.available)),
                                    r = n.find((e => 1 == l ? e.option2 == d && e.option1 == c && e.option3 == i : 2 == l ? e.option3 == d && e.option1 == c && e.option2 == i : e.option1 == d && e.option2 == c && e.option3 == i));
                                null == s ? null == r ? (o.removeClass("soldout available").addClass("unavailable"), o.find('input[type="radio"]').prop("checked", !1)) : (o.removeClass("unavailable available").addClass("soldout").find(".single-action-selector").attr("data-variant-id", r.title), o.find('input[type="radio"]').prop("disabled", !1)) : (o.removeClass("unavailable soldout").addClass("available"), o.find('input[type="radio"]').prop("disabled", !1))
                            }))
                    }
                })), s.find(".selector-wrapper:not(.option-color)").each(((t, a) => {
                    var o = e(a);
                    o.find(".swatch-element").find("input:checked").length < 1 && (o.find(".swatch-element.available").length > 0 ? o.find(".swatch-element.available").eq("0").find(".single-label").trigger("click") : o.find(".swatch-element.soldout").eq("0").find(".single-label").trigger("click"))
                })), t.hasClass("quick_shop_option_2")) {
                var m = a.find("[data-quickshop]").eq(1).find('[name="id"]').val(),
                    w = window[`quick_view_inven_array_${u}`];
                if (null != w) {
                    var f = w[m],
                        g = parseInt(f),
                        v = a.find('input[name="quantity"]').eq(0);
                    v.attr("data-inventory-quantity", g), v.val() > g && v.val(g)
                }
            }
        },
        initAddToCartQuickShop: function(e, t) {
            var a = t.find('[name="id"]').val();
            i.actionAddToCart(e, a, 1)
        },
        initAddToCart: function() {
            a.off("click.addToCart").on("click.addToCart", "[data-btn-addtocart]", (t => {
                t.preventDefault(), t.stopPropagation();
                var o = e(t.target);
                o.parents(".product-item"), a.find("#halo-card-mobile-popup"), a.find(".quickshop-popup-show");
                if (o.closest("product-form").length > 0) {
                    var n = o.closest("form");
                    i.actionAddToCart2(o, n)
                } else if (o.hasClass("is-notify-me") || o.hasClass("is-soldout")) o.hasClass("is-notify-me") && i.notifyInStockPopup(o);
                else {
                    var s = o.parents("form"),
                        r = s.find('[name="id"]').val(),
                        l = s.find('[name="quantity"]').val();
                    input = s.find('[name="quantity"]').eq(0), null == l && (l = 1), i.actionAddToCart(o, r, l, input)
                }
            })), a.on("click", "[data-close-add-to-cart-popup]", (e => {
                e.preventDefault(), e.stopPropagation(), t.removeClass("add-to-cart-show")
            })), a.on("click", (a => {
                t.hasClass("add-to-cart-show") && 0 === e(a.target).closest("[data-add-to-cart-popup]").length && t.removeClass("add-to-cart-show")
            }))
        },
        actionAddToCart: function(o, n, s, r) {
            window.variantStrings.submit, window.variantStrings.addingToCart, window.variantStrings.addedToCart;
            o.hasClass("button-text-change") && o.text(), o.addClass("is-loading"), t.hasClass("quick-view-show") ? Shopify.addItem(n, s, (() => {
                "cart" == window.after_add_to_cart.type ? i.redirectTo(window.routes.cart) : Shopify.getCart((e => {
                    t.addClass("cart-sidebar-show"), i.updateSidebarCart(e), t.find("[data-cart-count]").text(e.item_count), o.removeClass("is-loading")
                }))
            }), r) : Shopify.addItem(n, s, (() => {
                switch (o.removeClass("is-loading"), t.hasClass("quickshop-popup-show") && t.hasClass("quick_shop_option_3") && (t.removeClass("quickshop-popup-show"), e(".quickshop-popup-show").removeClass("quickshop-popup-show")), t.hasClass("quickshop-list-view-show") && t.removeClass("quickshop-list-view-show"), t.hasClass("show-mobile-options") && (t.removeClass("show-mobile-options"), e(".background-overlay").addClass("hold")), t.hasClass("quick_shop_popup_mobile") && t.hasClass("quick_shop_option_2") && (t.removeClass("quick_shop_popup_mobile"), a.find("#halo-card-mobile-popup").removeClass("show"), a.find(".quickshop-popup-show").each(((t, a) => {
                        e(a).removeClass("quickshop-popup-show")
                    }))), window.after_add_to_cart.type) {
                    case "cart":
                        i.redirectTo(window.routes.cart);
                        break;
                    case "quick_cart":
                        window.quick_cart.show ? Shopify.getCart((a => {
                            "popup" == window.quick_cart.type || (t.addClass("cart-sidebar-show"), i.updateSidebarCart(a)), o.removeClass("is-loading"), e(".background-overlay").removeClass("hold")
                        })) : i.redirectTo(window.routes.cart);
                        break;
                    case "popup_cart_1":
                        Shopify.getCart((a => {
                            i.updatePopupCart(a, 1), i.updateSidebarCart(a), t.addClass("add-to-cart-show"), o.removeClass("is-loading"), e(".background-overlay").removeClass("hold")
                        }))
                }
            }), r)
        },
        actionAddToCart2: function(a, o) {
            fetchConfig("javascript");
            window.variantStrings.submit, window.variantStrings.addingToCart, window.variantStrings.addedToCart;
            a.hasClass("button-text-change") && a.text(), a.addClass("is-loading");
            let n = document.querySelector('[data-type="add-to-cart-form"]'),
                s = new FormData(n);
            document.querySelectorAll('input[name^="properties"]').forEach((e => {
                null != e.value && ("file" == e.type ? s.append(e.name, e.files[0]) : s.append(e.name, e.value))
            }));
            if (!i.checkSufficientStock(o) && t.hasClass("quickshop-popup-show")) return alert(window.cartStrings.addProductOutQuantity), void a.removeClass("is-loading");
            const r = () => {
                fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    body: s
                }).then((e => e.json())).catch((e => {
                    console.error("Error:", e)
                })).finally((() => {
                    if (t.hasClass("quickshop-popup-show") && t.removeClass("quickshop-popup-show"), t.hasClass("quick-view-show")) "cart" == window.after_add_to_cart.type ? i.redirectTo(window.routes.cart) : Shopify.getCart((e => {
                        t.find("[data-cart-count]").text(e.item_count), a.removeClass("is-loading")
                    }));
                    else switch (window.after_add_to_cart.type) {
                        case "cart":
                            i.redirectTo(window.routes.cart);
                            break;
                        case "quick_cart":
                            window.quick_cart.show ? Shopify.getCart((e => {
                                "popup" == window.quick_cart.type || (t.addClass("cart-sidebar-show"), i.updateSidebarCart(e)), a.removeClass("is-loading")
                            })) : i.redirectTo(window.routes.cart);
                            break;
                        case "popup_cart_1":
                            Shopify.getCart((e => {
                                i.updatePopupCart(e, 1), i.updateSidebarCart(e), t.addClass("add-to-cart-show"), a.removeClass("is-loading")
                            }))
                    }
                }))
            };
            fetch(window.Shopify.routes.root + "cart.js", {
                method: "GET"
            }).then((e => e.json())).then((t => {
                const a = parseInt(e(n).serialize().split("id=")[1]),
                    i = t.items.find((e => e.variant_id == a)),
                    s = i?.quantity,
                    l = parseInt(o.find("[data-inventory-quantity]").val()),
                    d = parseInt(o.find("[data-inventory-quantity]").data("inventory-quantity"));
                if (!s || !d) return r();
                if (s + l > d) {
                    const e = d - s;
                    throw new Error(`You ${e>0?`can only add ${e}`:"cannot add"} more of the items into the cart`)
                }
                r()
            })).catch((e => {
                this.showWarning(e)
            })).finally((() => {
                a.removeClass("is-loading")
            }))
        },
        checkSufficientStock: function(e) {
            return e.find("[data-inventory-quantity]").data("inventory-quantity") >= parseInt(e.find("[data-inventory-quantity]").val())
        },
        updateContentQuickshopOption3: function(a) {
            var o = e("#halo-quickshop-popup-option-3"),
                n = o.find(".halo-popup-content");
            e.ajax({
                type: "get",
                url: window.routes.root + "/products/" + a + "?view=ajax_quick_shop",
                beforeSend: function() {
                    e("[data-quick-view-popup] .halo-popup-content").empty()
                },
                success: function(e) {
                    n.html(e)
                },
                error: function(t, a) {
                    i.showWarning(e.parseJSON(t.responseText).description)
                },
                complete: function() {
                    var e = o.find(".quickshop");
                    i.productImageGallery(e), setTimeout((() => {
                        t.addClass("quickshop-popup-show")
                    }), 150)
                }
            })
        },
        appendProductQuickShopOption2: function(o) {
            if (window.innerWidth <= 767) {
                var i = a.find("#halo-card-mobile-popup"),
                    n = o.clone();
                i.find(".halo-popup-content").empty(), i.find(".halo-popup-content").append(n);
                var s = i.find("[data-quickshop] form").eq("0"),
                    r = s.attr("id") + "mobile";
                s.attr("id", r);
                var l = s.find(".single-option"),
                    d = s.find(".single-label");
                l.each(((t, a) => {
                    e(a).attr("id", e(a).attr("id") + "-mobile")
                })), d.each(((t, a) => {
                    e(a).attr("for", e(a).attr("for") + "-mobile")
                })), i.addClass("show"), a.on("click", (a => {
                    e(a.target).hasClass("background-overlay") && (i.removeClass("show"), t.removeClass("quick_shop_popup_mobile"), o.removeClass("quickshop-popup-show"))
                }))
            }
        },
        isRunningInIframe: function() {
            try {
                return window.self !== window.top
            } catch (e) {
                return !0
            }
        },
        redirectTo: function(e) {
            i.isRunningInIframe() && !window.iframeSdk ? window.top.location = e : window.location = e
        },
        initBeforeYouLeave: function() {
            var a = e("#halo-leave-sidebar"),
                o = a.data("time"),
                i = 0;
            if (a.length) {
                setInterval((() => {
                    ! function() {
                        if ((i += 1) >= 1 && !t.hasClass("before-you-leave-show")) {
                            if (a.find(".products-carousel").length > 0) ! function(e) {
                                e.hasClass("slick-slider") || e.slick({
                                    dots: !0,
                                    arrows: !1,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    slidesPerRow: 1,
                                    rows: 3,
                                    infinite: !1,
                                    nextArrow: window.arrows.icon_next,
                                    prevArrow: window.arrows.icon_prev
                                })
                            }(a.find(".products-carousel"));
                            t.addClass("before-you-leave-show")
                        }
                    }()
                }), o);
                t.on("mousemove keydown scroll", (() => {
                    i = -1
                })), t.on("click", "[data-close-before-you-leave]", (e => {
                    e.preventDefault(), t.removeClass("before-you-leave-show")
                })), t.on("click", (a => {
                    t.hasClass("before-you-leave-show") && 0 === e(a.target).closest("#halo-leave-sidebar").length && t.removeClass("before-you-leave-show")
                }))
            }
        },
        initQuickCart: function() {
            window.quick_cart.show && ("popup" == window.quick_cart.type || i.initSidebarCart()), i.initEventQuickCart()
        },
        initEventQuickCart: function() {
            i.removeItemQuickCart(), i.updateQuantityItemQuickCart(), i.editQuickCart()
        },
        initFreeShippingMessage: function() {
            e.getJSON("/cart.js", (e => {
                i.freeShippingMessage(e)
            }))
        },
        freeShippingMessage: function(t) {
            var a = e(".haloCalculatorShipping"),
                o = e("[data-shipping-progress]"),
                n = e("[data-shipping-message]"),
                s = o.data("text-enabled"),
                r = window.free_shipping_text.free_shipping_message,
                l = window.free_shipping_text.free_shipping_message_1,
                d = window.free_shipping_text.free_shipping_message_2,
                c = window.free_shipping_text.free_shipping_message_3,
                p = window.free_shipping_text.free_shipping_message_4,
                u = 0,
                h = (window.free_shipping_text.free_shipping_1, parseInt(window.free_shipping_price)),
                m = parseInt(t.total_price) / 100,
                w = Math.round(100 * m / h);
            0 == m ? (o.addClass("progress-hidden"), r = "<span>" + r + " " + Shopify.formatMoney(100 * h, window.money_format) + "!</span>") : m >= h ? (o.removeClass("progress-hidden"), 1, r = l) : (o.removeClass("progress-hidden"), u = parseInt(h - m), r = "<span>" + d + " </span>" + Shopify.formatMoney(100 * u, window.money_format) + "<span> " + c + ' </span><span class="text">' + p + "</span>", window.free_shipping_text.free_shipping_2), w >= 100 && (w = 100);
            var f = "progress-free";
            0 == w ? f = "none" : w <= 30 ? f = "progress-30" : w <= 60 ? f = "progress-60" : w < 100 && (f = "progress-100");
            setTimeout((() => {
                a.find(".progress-meter").removeClass("animated-loading")
            }), 200), setTimeout((() => {
                o.removeClass("progress-30 progress-60 progress-100 progress-free"), o.addClass(f), o.find(".progress-meter").css("width", w + "%"), s && o.find(".progress-meter .text").text(w + "%"), n.html(r), i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format")
            }), 400)
        },
        productCollectionCartSlider: function() {
            e("[data-product-collection-cart]").each(((t, a) => {
                var o = e(a).find(".products-carousel"),
                    i = o.data("item-dots"),
                    n = o.data("item-arrows");
                o.length > 0 && (o.hasClass("slick-initialized") || o.slick({
                    mobileFirst: !0,
                    adaptiveHeight: !1,
                    infinite: !1,
                    vertical: !1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: !0,
                    arrows: !1,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    responsive: [{
                        breakpoint: 1025,
                        settings: {
                            dots: i,
                            arrows: n
                        }
                    }]
                }))
            }))
        },
        updatePopupCart: function(a, o) {
            var i = a.items[0],
                n = e("[data-add-to-cart-popup]").find(".product-added"),
                s = n.find(".product-title"),
                r = n.find(".product-image"),
                l = i.product_title,
                d = i.featured_image,
                c = '<img src="' + d.url + '" alt="' + d.alt + '" title="' + d.alt + '"/>';
            r.attr("href", i.url).html(c), s.find(".title").attr("href", i.url).empty().append(l), Shopify.getCart((e => {
                t.find("[data-cart-count]").text(e.item_count)
            }))
        },
        initSidebarCart: function() {
            var o = e("[data-cart-sidebar]");
            Shopify.getCart((e => {
                i.updateSidebarCart(e)
            })), t.hasClass("template-cart") ? o.on("click", (t => {
                t.preventDefault(), t.stopPropagation(), e("html, body").animate({
                    scrollTop: 0
                }, 700)
            })) : o.on("click", (e => {
                e.preventDefault(), e.stopPropagation(), t.addClass("cart-sidebar-show")
            })), a.on("click", "[data-close-cart-sidebar]", (e => {
                e.preventDefault(), e.stopPropagation(), t.hasClass("cart-sidebar-show") && t.removeClass("cart-sidebar-show")
            })), t.on("click", ".background-overlay", (a => {
                !t.hasClass("cart-sidebar-show") || t.hasClass("edit-cart-show") || t.hasClass("term-condition-show") || t.hasClass("has-warning") || 0 === e(a.target).closest("#halo-cart-sidebar").length && 0 === e(a.target).closest("[data-cart-sidebar]").length && 0 === e(a.target).closest("[data-edit-cart-popup]").length && 0 === e(a.target).closest("[data-warning-popup]").length && 0 === e(a.target).closest("[data-term-condition-popup]").length && t.removeClass("cart-sidebar-show")
            }))
        },
        updateSidebarCart: function(a) {
            if (!e.isEmptyObject(a)) {
                const o = e("#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper"),
                    n = '<div class="loading-overlay loading-overlay--custom">                        <div class="loading-overlay__spinner">                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>                            </svg>                        </div>                    </div>',
                    s = "is-loading";
                o.addClass(s).prepend(n), e.ajax({
                    type: "GET",
                    url: window.routes.root + "/cart?view=ajax_side_cart",
                    cache: !1,
                    success: function(t) {
                        var a = e(t);
                        o.removeClass(s).html(a)
                    },
                    error: function(t, a) {
                        i.showWarning(e.parseJSON(t.responseText).description)
                    },
                    complete: function() {
                        t.find("[data-cart-count]").text(a.item_count), i.productCollectionCartSlider(), i.initFreeShippingMessage(), i.updateGiftWrapper(), i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format")
                    }
                })
            }
        },
        updateGiftWrapper: function() {
            let t;
            e("#gift-wrapping").off("click").on("click", (e => {
                e.stopPropagation(), e.preventDefault(), clearTimeout(t), t = setTimeout((() => {
                    const t = e.target.dataset.giftId;
                    Shopify.addItem(t, 1, (() => {
                        Shopify.getCart((e => {
                            i.updateSidebarCart(e)
                        }))
                    }))
                }), 250)
            })), e("#cart-gift-wrapping").off("click").on("click", (a => {
                a.stopPropagation(), a.preventDefault();
                var o = e(a.currentTarget),
                    n = o.attr("data-adding-text");
                o.text(n), clearTimeout(t), t = setTimeout((() => {
                    const e = a.target.dataset.giftId;
                    Shopify.addItem(e, 1, (() => {
                        Shopify.getCart((e => {
                            i.updateCart(e)
                        }))
                    }))
                }), 250)
            }))
        },
        removeItemQuickCart: function() {
            a.on("click", "[data-cart-remove]", (a => {
                a.preventDefault(), a.stopPropagation();
                var o = e(a.currentTarget),
                    n = (o.attr("data-cart-remove-id"), e("#cart-gift-wrapping").attr("data-add-text")),
                    s = o.data("line");
                e("#cart-gift-wrapping").text(n), Shopify.removeItem(s, (e => {
                    t.hasClass("template-cart") ? i.updateCart(e) : t.hasClass("cart-modal-show") || t.hasClass("cart-sidebar-show") && i.updateSidebarCart(e)
                }))
            }))
        },
        updateCart: function(a) {
            if (!e.isEmptyObject(a)) {
                const o = e("#main-cart-items").data("id"),
                    n = e("[data-cart]"),
                    s = n.find("[data-cart-content]"),
                    r = n.find("[data-cart-total]"),
                    l = '<div class="loading-overlay loading-overlay--custom">                        <div class="loading-overlay__spinner">                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>                            </svg>                        </div>                    </div>',
                    d = "is-loading";
                n.addClass(d).prepend(l), e.ajax({
                    type: "GET",
                    url: `/cart?section_id=${o}`,
                    cache: !1,
                    success: function(t) {
                        var o = e(t);
                        if (n.removeClass(d), n.find(".loading-overlay").remove(), a.item_count > 0) {
                            var i = o.find("[data-cart-content] .cart").html(),
                                l = o.find("[data-cart-total] .cart-total-subtotal").html(),
                                c = o.find("[data-cart-total] .cart-total-grandtotal").html();
                            if (s.find(".cart").html(i), r.find(".cart-total-subtotal").html(l), r.find(".cart-total-grandtotal").html(c), o.find(".haloCalculatorShipping").length > 0) {
                                var p = o.find(".haloCalculatorShipping");
                                n.find(".haloCalculatorShipping").replaceWith(p)
                            }
                        } else {
                            i = o.find("#main-cart-items").html();
                            var u = o.find(".page-header").html();
                            e("#main-cart-items").html(i), e(".page-header").html(u)
                        }
                    },
                    error: function(t, a) {
                        i.showWarning(e.parseJSON(t.responseText).description)
                    },
                    complete: function() {
                        if (t.find("[data-cart-count]").text(a.item_count), i.initFreeShippingMessage(), i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format"), t.hasClass("template-cart")) {
                            const t = document.getElementById("cart-gift-wrapping"),
                                a = t?.dataset.isChecked,
                                o = t?.dataset.giftId;
                            if ("true" === a) {
                                e("#is-a-gift").hide();
                                const a = document.querySelector(`[data-cart-remove-id="${o}"]`),
                                    i = document.querySelector(`[data-cart-quantity-id="${o}"]`);
                                a?.addEventListener("click", (() => {
                                    t.dataset.isChecked = "false"
                                })), i?.addEventListener("change", (e => {
                                    Number(e.target.value) <= 0 && (t.dataset.isChecked = "false")
                                }))
                            } else e("#is-a-gift").show()
                        }
                    }
                })
            }
        },
        updateQuantityItemQuickCart: function() {
            a.on("change", "[data-cart-quantity]", (a => {
                a.preventDefault(), a.stopPropagation();
                var o = e(a.currentTarget),
                    n = (o.attr("data-cart-quantity-id"), o.data("line")),
                    s = parseInt(o.val()),
                    r = parseInt(o.data("inventory-quantity"));
                let l = !0;
                r < s && r > 0 && (s = r, l = !1), Shopify.changeItem(n, s, (e => {
                    t.hasClass("template-cart") ? i.updateCart(e) : t.hasClass("cart-modal-show") || t.hasClass("cart-sidebar-show") && i.updateSidebarCart(e), l || i.showWarning(`${window.cartStrings.addProductOutQuantity}`)
                }))
            }))
        },
        editQuickCart: function() {
            a.on("click", "[data-open-edit-cart]", (a => {
                a.preventDefault(), a.stopPropagation();
                var o = e(a.currentTarget),
                    n = o.data("edit-cart-url"),
                    s = o.data("edit-cart-id"),
                    r = o.data("line"),
                    l = o.data("edit-cart-quantity");
                o.parents(".previewCartItem").find("previewCartItem-variant").text();
                const d = e("[data-edit-cart-popup]").find(".halo-popup-content");
                e.ajax({
                    type: "get",
                    url: n,
                    cache: !1,
                    dataType: "html",
                    beforeSend: function() {
                        t.hasClass("template-cart")
                    },
                    success: function(e) {
                        d.html(e), d.find("[data-template-cart-edit]").attr({
                            "data-cart-update-id": s,
                            "data-line": r
                        }), d.find(".product-edit-item").find('input[name="quantity"]').val(l)
                    },
                    error: function(a, o) {
                        i.showWarning(e.parseJSON(a.responseText).description), t.hasClass("template-cart")
                    },
                    complete: function() {
                        t.addClass("edit-cart-show"), t.hasClass("template-cart"), i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format")
                    }
                })
            })), a.on("click", "[data-close-edit-cart]", (e => {
                e.preventDefault(), e.stopPropagation(), t.removeClass("edit-cart-show")
            })), a.on("click", (a => {
                t.hasClass("edit-cart-show") && 0 === e(a.target).closest("[data-edit-cart-popup]").length && 0 === e(a.target).closest("[data-open-edit-cart]").length && t.removeClass("edit-cart-show")
            })), i.addMoreItemEditCart(), i.addAllItemCartEdit()
        },
        addMoreItemEditCart: function() {
            a.on("click", "[data-edit-cart-add-more]", (t => {
                t.preventDefault(), t.stopPropagation();
                var a = e("[data-template-cart-edit]"),
                    o = e(t.target).parents(".product-edit-item"),
                    n = parseInt(a.attr("data-count")),
                    s = o.clone().removeClass("product-edit-itemFirst");
                cloneProductId = s.attr("id") + n, s.attr("id", cloneProductId), i.updateClonedProductAttributes(s, n), s.insertAfter(o), n += 1, a.attr("data-count", n)
            })), a.on("click", "[data-edit-cart-remove]", (t => {
                t.preventDefault(), t.stopPropagation(), e(t.target).parents(".product-edit-item").remove()
            }))
        },
        updateClonedProductAttributes: function(t, a) {
            var o = e(".shopify-product-form", t),
                i = o.attr("id") + a;
            o.attr("id", i), e(".product-form__radio", t).each(((t, o) => {
                var i = e(o),
                    n = i.next(),
                    s = n.attr("for") + a,
                    r = i.attr("name");
                n.attr("for", s), i.attr({
                    id: s,
                    name: r + a
                })
            }))
        },
        addAllItemCartEdit: function() {
            a.on("click", "#add-all-to-cart", (a => {
                a.preventDefault(), a.stopPropagation();
                var o = e(a.currentTarget),
                    n = e("[data-template-cart-edit]"),
                    s = n.find(".product-edit-item.isChecked");
                n.attr("data-cart-update-id");
                productLine = n.data("line"), s.length > 0 ? (o.addClass("is-loading"), Shopify.removeItem(productLine, (a => {
                    if (!e.isEmptyObject(a)) {
                        var n = [];
                        s.each(((t, a) => {
                            var o, i = e(a),
                                s = i.find('input[name="id"]').val(),
                                r = parseInt(i.find('input[name="quantity"]').val());
                            n.push((o = {
                                type: "post",
                                url: window.routes.root + "/cart/add.js",
                                data: "quantity=" + r + "&id=" + s,
                                dataType: "json",
                                async: !1
                            }, e.ajax(o)))
                        })), n.length > 0 && e.when.apply(e, n).done((e => {
                            setTimeout((function() {
                                o.removeClass("is-loading")
                            }), 1e3), Shopify.getCart((e => {
                                t.removeClass("edit-cart-show"), t.hasClass("template-cart") ? i.updateCart(e) : t.hasClass("cart-modal-show") || t.hasClass("cart-sidebar-show") && i.updateSidebarCart(e)
                            }))
                        }))
                    }
                }))) : alert(window.variantStrings.addToCart_message)
            }))
        },
        initNotifyInStock: function() {
            a.on("click", "[data-open-notify-popup]", (t => {
                t.preventDefault(), t.stopPropagation();
                var a = e(t.currentTarget);
                i.notifyInStockPopup(a)
            })), a.on("click", "[data-close-notify-popup]", (e => {
                e.preventDefault(), e.stopPropagation(), t.removeClass("notify-me-show")
            })), a.on("click", (a => {
                t.hasClass("notify-me-show") && 0 === e(a.target).closest("[data-open-notify-popup]").length && 0 === e(a.target).closest("[data-notify-popup]").length && t.removeClass("notify-me-show")
            })), a.on("click", "[data-form-notify]", (t => {
                t.preventDefault(), t.stopPropagation();
                var a = e(t.currentTarget);
                i.notifyInStockAction(a)
            }))
        },
        notifyInStockPopup: function(a) {
            var o, i = a.parents(".product-item"),
                n = i.find(".card-title").data("product-title"),
                s = i.find(".card-title").data("product-url"),
                r = e("[data-notify-popup]");
            o = a.hasClass("is-notify-me") ? i.find(".card-swatch .swatch-label.is-active").attr("title") : a.data("variant-id"), r.find('[name="halo-notify-product-title"]').val(e.trim(n)), r.find('[name="halo-notify-product-link"]').val(s), o && r.find('[name="halo-notify-product-variant"]').val(o), t.addClass("notify-me-show")
        },
        notifyInStockAction: function(t) {
            var a, o = !0,
                n = t.parents(".halo-notifyMe"),
                s = n.find(".notifyMe-form"),
                r = n.find(".notifyMe-text"),
                l = n.find('input[name="email"]').val();
            if (/^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/.test(l) && l ? (n.find(".form-field").removeClass("form-field--error").addClass("form-field--success"), r.html("").hide()) : (n.find(".form-field").removeClass("form-field--success").addClass("form-field--error"), o = !1, a = '<div class="alertBox alertBox--error"><p class="alertBox-message">' + window.notify_me.error + "</p></div>", r.html(a).show()), o) {
                var d = n.find('[name="halo-notify-product-site"]').val(),
                    c = n.find('[name="halo-notify-product-site-url"]').val(),
                    p = window.notify_me.mail,
                    u = window.notify_me.subject,
                    h = window.notify_me.label,
                    m = n.find('[name="halo-notify-product-title"]').val(),
                    w = n.find('[name="halo-notify-product-link"]').val(),
                    f = n.find('[name="halo-notify-product-variant"]').val(),
                    g = '<div style="margin:30px auto;width:650px;border:10px solid #f7f7f7"><div style="border:1px solid #dedede">                        <h2 style="margin: 0; padding:20px 20px 20px;background:#f7f7f7;color:#555;font-size:2em;text-align:center;">' + u + "</h2>";
                g += '<table style="margin:0px 0 0;padding:30px 30px 30px;line-height:1.7em">                          <tr><td style="padding: 5px 25px 5px 0;"><strong>Product Name: </strong> ' + m + '</td></tr>                          <tr><td style="padding: 5px 25px 5px 0;"><strong>Product URL: </strong> ' + w + '</td></tr>                          <tr><td style="padding: 5px 25px 5px 0;"><strong>Email Request: </strong> ' + l + "</td></tr>                          " + ("" != f ? '<tr><td style="padding: 5px 25px 5px 0;"><strong>Product Variant: </strong>' + f + "</td></tr>" : "") + "                       </table>", g += '<a href="' + c + '" style="display:block;padding:30px 0;background:#484848;color:#fff;text-decoration:none;text-align:center;text-transform:uppercase">&nbsp;' + d + "&nbsp;</a>";
                var v = {
                    api: "i_send_mail",
                    subject: u,
                    email: p,
                    from_name: h,
                    email_from: l,
                    message: g += "</div></div>"
                };
                e.post("https://themevale.net/tools/sendmail/quotecart/sendmail.php", v, (e => {
                    "error" == e.type ? a = '<div class="alertBox alertBox--error"><p class="alertBox-message">' + e.text + "</p></div>" : (a = '<div class="alertBox alertBox--success"><p class="alertBox-message">' + window.notify_me.success + "</p></div>", i.resetForm(s)), r.html(a).show()
                }), "json")
            }
        },
        initAskAnExpert: function() {
            a.on("click", "[data-open-ask-an-expert]", (a => {
                a.preventDefault(), a.stopPropagation();
                var o, i = e("[data-ask-an-expert-popup]").find(".halo-popup-content");
                if (t.hasClass("template-product")) {
                    var n = e(".productView").data("product-handle");
                    o = window.routes.root + "/products/" + n + "?view=ajax_ask_an_expert"
                } else if (t.hasClass("quick-view-show")) {
                    n = e(".halo-quickView").data("product-quickview-handle");
                    o = window.routes.root + "/products/" + n + "?view=ajax_ask_an_expert"
                } else o = window.routes.root + "/search?view=ajax_ask_an_expert";
                e.ajax({
                    type: "get",
                    url: o,
                    beforeSend: function() {
                        i.empty()
                    },
                    success: function(e) {
                        i.html(e)
                    },
                    error: function(t, a) {
                        alert(e.parseJSON(t.responseText).description)
                    },
                    complete: function() {
                        t.addClass("ask-an-expert-show")
                    }
                })
            })), a.on("click", "#halo-ask-an-expert-button", (t => {
                t.preventDefault(), t.stopPropagation();
                var a = e(t.currentTarget);
                i.askAnExpertAction(a)
            })), a.on("click", "[data-close-ask-an-expert]", (e => {
                e.preventDefault(), e.stopPropagation(), t.removeClass("ask-an-expert-show")
            })), a.on("click", (a => {
                t.hasClass("ask-an-expert-show") && 0 === e(a.target).closest("[data-open-ask-an-expert]").length && 0 === e(a.target).closest("#halo-ask-an-expert-popup").length && t.removeClass("ask-an-expert-show")
            }))
        },
        askAnExpertAction: function(t) {
            var a, o = !0,
                n = t.parents(".halo-ask-an-expert"),
                s = n.find(".halo-ask-an-expert-form"),
                r = n.find(".message"),
                l = n.find('input[name="askAnExpertMail"]').val(),
                d = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            if (e("input[required], textarea[required]", s).each(((t, i) => {
                    e.trim(e(i).val()) ? (e(i).parent(".form-field").removeClass("form-field--error").addClass("form-field--success"), r.html("").hide()) : (e(i).parent(".form-field").removeClass("form-field--success").addClass("form-field--error"), a = '<div class="alertBox alertBox--error"><p class="alertBox-message">' + window.ask_an_expert.error_2 + "</p></div>", r.html(a).show(), o = !1), "askAnExpertMail" != e(i).attr("name") || d.test(l) || (e(i).parent(".form-field").removeClass("form-field--success").addClass("form-field--error"), a = '<div class="alertBox alertBox--error"><p class="alertBox-message">' + window.ask_an_expert.error_1 + "</p></div>", r.html(a).show(), o = !1)
                })), o) {
                var c = window.ask_an_expert.mail,
                    p = window.ask_an_expert.subject,
                    u = window.ask_an_expert.label,
                    h = n.find('[name="askAnExpertName"]').val(),
                    m = l,
                    w = n.find('[name="askAnExpertPhone"]').val(),
                    f = n.find("input[name=askAnExpertRadioFirst]:checked").val(),
                    g = n.find("input[name=askAnExpertRadioSecond]:checked").val(),
                    v = n.find('[name="askAnExpertMessag"]').val(),
                    k = "<div style='border: 1px solid #e6e6e6;padding: 30px;max-width: 500px;margin: 0 auto;'>                                    <h2 style='margin-top:0;margin-bottom:30px;color: #000000;'>" + p + "</h2>                                    <p style='border-bottom: 1px solid #e6e6e6;padding-bottom: 23px;margin-bottom:25px;color: #000000;'>You received a new message from your online store's ask an expert form.</p>                                    <table style='width:100%;'>";
                if (n.hasClass("has-product")) {
                    var b = n.find('[name="halo-product-title"]').val(),
                        y = n.find('[name="halo-product-link"]').val();
                    k += "<tr>                                    <td style='border-bottom: 1px solid #e6e6e6;padding-bottom: 25px;margin-bottom:25px;width:50%;'>                                        <img style='width: 100px' src='" + n.find('[name="halo-product-image"]').val() + "' alt='" + b + "' title='" + b + "'>                                    </td>                                    <td style='border-bottom: 1px solid #e6e6e6;padding-bottom: 25px;margin-bottom:25px;'>                                        <a href='" + y + "'>" + b + "</a>                                    </td>                                </tr>"
                }
                k += "<tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>" + window.ask_an_expert.customer_name + ": </strong></td><td>" + h + "</td></tr>                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>" + window.ask_an_expert.customer_mail + ": </strong></td><td>" + m + "</td></tr>                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>" + window.ask_an_expert.customer_phone + ": </strong></td><td>" + w + "</td></tr>                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>" + window.ask_an_expert.type_radio1 + " </strong></td><td>" + f + "</td></tr>                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>" + window.ask_an_expert.type_radio2 + ": </strong></td><td>" + g + "</td></tr>                            <tr><td style='padding-right: 10px;vertical-align: top;width:50%;'><strong>" + window.ask_an_expert.customer_message + "? </strong></td><td>" + v + "</td></tr>                        </table></div>";
                var C = {
                    api: "i_send_mail",
                    subject: p,
                    email: c,
                    from_name: u,
                    email_from: l,
                    message: k
                };
                e.post("https://themevale.net/tools/sendmail/quotecart/sendmail.php", C, (e => {
                    "error" == e.type ? a = '<div class="alertBox alertBox--error"><p class="alertBox-message">' + e.text + "</p></div>" : (a = '<div class="alertBox alertBox--success"><p class="alertBox-message">' + window.ask_an_expert.success + "</p></div>", i.resetForm(s), s.hide()), r.html(a).show()
                }), "json")
            }
        },
        resetForm: function(t) {
            e(".form-field", t).removeClass("form-field--success form-field--error"), e("input[type=email], input[type=text], textarea", t).val("")
        },
        initCompareProduct: function() {
            var o = e("a[data-compare-link]");
            window.compare.show && (i.setLocalStorageProductForCompare(o), i.setAddorRemoveProductForCompare(o), i.setProductForCompare(), a.on("click", "[data-close-compare-product-popup]", (e => {
                e.preventDefault(), e.stopPropagation(), t.removeClass("compare-product-show")
            })), a.on("click", (a => {
                t.hasClass("compare-product-show") && 0 === e(a.target).closest("[data-compare-link]").length && 0 === e(a.target).closest("[data-compare-product-popup]").length && t.removeClass("compare-product-show")
            })))
        },
        setLocalStorageProductForCompare: function(t) {
            var a = JSON.parse(localStorage.getItem("compareItem")),
                o = e("[data-product-compare-handle]");
            null !== a && o.length > 0 && (o.each(((t, o) => {
                var i = e(o),
                    n = i.data("product-compare-handle");
                a.indexOf(n) >= 0 ? (i.find(".compare-icon").addClass("is-checked"), i.find(".text").text(window.compare.added), i.find("input").prop("checked", !0)) : (i.find(".compare-icon").removeClass("is-checked"), i.find(".text").text(window.compare.add), i.find("input").prop("checked", !1))
            })), i.updateCounterCompare(t))
        },
        setAddorRemoveProductForCompare: function(t) {
            a.on("change", "[data-product-compare] input", (a => {
                var o = e(a.currentTarget),
                    n = o.parents(".card-compare"),
                    s = o.val(),
                    r = JSON.parse(localStorage.getItem("compareItem"));
                r = i.uniqueArray(r), a.currentTarget.checked ? (n.find(".compare-icon").addClass("is-checked"), n.find(".text").text(window.compare.added), n.find("input").prop("checked", !0), i.incrementCounterCompare(r, s, t)) : (n.find(".compare-icon").removeClass("is-checked"), n.find(".text").text(window.compare.add), n.find("input").prop("checked", !1), i.decrementCounterCompare(r, s, t))
            }))
        },
        setProductForCompare: function() {
            a.on("click", "[data-compare-link]", (e => {
                e.preventDefault(), e.stopPropagation();
                var t = JSON.parse(localStorage.getItem("compareItem"));
                if (t.length <= 1) return alert(window.compare.message), !1;
                i.updateContentCompareProduct(t)
            })), a.on("click", "[data-compare-remove]", (a => {
                a.preventDefault(), a.stopPropagation();
                var o = e(a.currentTarget).data("compare-item"),
                    n = e("[data-compare-product-popup] .compareTable"),
                    s = n.find('.compareTable-row[data-product-compare-id="' + o + '"]'),
                    r = s.data("compare-product-handle");
                if (1 == n.find("tbody .compareTable-row").length) {
                    s.remove();
                    var l = (c = JSON.parse(localStorage.getItem("compareItem"))).indexOf(r),
                        d = e("a[data-compare-link]");
                    l > -1 && (c.splice(l, 1), c = i.uniqueArray(c), localStorage.setItem("compareItem", JSON.stringify(c)), i.setLocalStorageProductForCompare(d), i.updateCounterCompare(d)), t.removeClass("compare-product-show")
                } else {
                    s.remove();
                    var c;
                    l = (c = JSON.parse(localStorage.getItem("compareItem"))).indexOf(r), d = e("a[data-compare-link]");
                    l > -1 && (c.splice(l, 1), c = i.uniqueArray(c), localStorage.setItem("compareItem", JSON.stringify(c)), i.setLocalStorageProductForCompare(d), i.updateCounterCompare(d))
                }
            }))
        },
        updateCounterCompare: function(e) {
            var t = JSON.parse(localStorage.getItem("compareItem"));
            t.length > 1 ? (e.parent().addClass("is-show"), e.find("span.countPill").html(t.length)) : e.parent().removeClass("is-show")
        },
        uniqueArray: function(t) {
            var a = [];
            return e.each(t, (function(t, o) {
                -1 == e.inArray(o, a) && a.push(o)
            })), a
        },
        incrementCounterCompare: function(e, t, a) {
            e.indexOf(t);
            e.push(t), e = i.uniqueArray(e), localStorage.setItem("compareItem", JSON.stringify(e)), i.updateCounterCompare(a)
        },
        decrementCounterCompare: function(e, t, a) {
            const o = e.indexOf(t);
            o > -1 && (e.splice(o, 1), e = i.uniqueArray(e), localStorage.setItem("compareItem", JSON.stringify(e)), i.updateCounterCompare(a))
        },
        updateContentCompareProduct: function(a) {
            var o = e("[data-compare-product-popup]").find(".compareTable");
            o.find("tbody").empty(), e.ajax({
                type: "get",
                url: window.routes.root + "/collections/all",
                cache: !1,
                data: {
                    view: "ajax_product_card_compare",
                    constraint: `limit=${a.length}+sectionId=list-compare+list_handle=` + encodeURIComponent(a)
                },
                beforeSend: function() {},
                success: function(e) {
                    o.find("tbody").append(e)
                },
                error: function(t, a) {
                    alert(e.parseJSON(t.responseText).description)
                },
                complete: function() {
                    t.addClass("compare-product-show")
                }
            })
        },
        initProductView: function(e) {
            i.productImageGallery(e), i.productLastSoldOut(e), i.productCustomerViewing(e), i.productCountdown(e), i.productSizeChart(e), i.productCustomCursor(e), i.productVideoGallery(e), i.initVariantImageGroup(e, window.variant_image_group)
        },
        initQuickView: function() {
            a.on("click", "[data-open-quick-view-popup]", (t => {
                t.preventDefault(), t.stopPropagation();
                var a = e(t.currentTarget).data("product-handle");
                i.updateContentQuickView(a)
            })), a.on("click", "[data-close-quick-view-popup]", (e => {
                e.preventDefault(), e.stopPropagation(), t.removeClass("quick-view-show")
            })), e(".background-overlay").off("click.closeQuickView").on("click.closeQuickView", (e => {
                !t.hasClass("quick-view-show") || t.hasClass("cart-sidebar-show") || t.hasClass("ask-an-expert-show") || t.hasClass("size-chart-show") || t.hasClass("compare-color-show") || t.hasClass("term-condition-show") || t.removeClass("quick-view-show")
            }))
        },
        updateContentQuickView: function(a) {
            var o = e("[data-quick-view-popup]"),
                n = o.find(".halo-popup-content");
            e.ajax({
                type: "get",
                url: window.routes.root + "/products/" + a + "?view=ajax_quick_view",
                beforeSend: function() {
                    n.empty(), e("#halo-quickshop-popup-option-3").find(".halo-popup-content").empty()
                },
                success: function(e) {
                    n.html(e)
                },
                error: function(t, a) {
                    alert(e.parseJSON(t.responseText).description)
                },
                complete: function() {
                    var n = o.find(".quickView");
                    const s = e(".halo-popup-content .halo-compare-color-popup li.item"),
                        r = e(".halo-popup-content .halo-compare-color-popup #sortTableList"),
                        l = e(".halo-popup-content .halo-compare-color-popup"),
                        d = e(".halo-popup-content .halo-size-chart-popup");
                    if (i.productImageGallery(n), i.productLastSoldOut(n), i.productCustomerViewing(n), i.productCountdown(n), i.productSizeChart(n), i.setProductForWishlist(a), i.initVariantImageGroup(n, window.variant_image_group_quick_view), t.addClass("quick-view-show"), window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(), r.attr("id", "quickViewSortTableList"), s.each(((t, a) => {
                            const o = e(a).find(".swatch-compare-color-option"),
                                i = e(a).find(".swatch-compare-color-label"),
                                n = o.attr("id");
                            o.attr("id", `quickView-${n}`).attr("name", `quickView-${n}`), i.attr("for", `quickView-${n}`)
                        })), l.attr("id", "quickView-halo-compare-color-popup"), d.attr("id", "quickView-halo-size-chart-popup"), e(".halo-productView .addthis_inline_share_toolbox").length) {
                        var c = e(".halo-productView .addthis_inline_share_toolbox").html();
                        e(".halo-popup-content .share-button__button").click((function() {
                            e(".halo-popup-content .addthis_inline_share_toolbox").append(c)
                        }))
                    }
                    const p = document.getElementById("quickViewSortTableList"),
                        u = e(".halo-popup-content .halo-compareColors-image");
                    if (window.innerWidth >= 1025 && p ? new Sortable(p, {
                            animation: 150
                        }) : u.on("click", ".item", (t => {
                            t.preventDefault();
                            var a = `swatch-compare-color-${t.currentTarget.classList[1].replace("item-","")}`;
                            e(document.getElementById(a)).trigger("click")
                        })), window.review.show_quick_view && e(".shopify-product-reviews-badge").length > 0) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                }
            })
        },
        productImageGallery: function(t) {
            var a = t.find(".productView-nav"),
                n = t.find('.productView-for:not(".mobile")'),
                s = t.find(".productView-for.mobile");
            if (!n.hasClass("slick-initialized") && !a.hasClass("slick-initialized")) {
                const m = a.data("arrows-desk"),
                    w = a.data("arrows-mobi"),
                    f = a.data("counter-mobi"),
                    g = a.data("media-count"),
                    v = parseInt(n.data("max-thumbnail-to-show"));
                let k, b;
                if (b = !a.closest(".productView").is(".layout-4") && n, a.hasClass("productView-nav-gallery")) {
                    var r = (c = t.find(".productView-nav.productView-nav-gallery")).data("media-count"),
                        l = 2,
                        d = 2;
                    1 == r && (l = 1, d = 1), 2 == r && (l = 2, d = 1), c.slick({
                        dots: !0,
                        rows: d,
                        arrows: m,
                        infinite: !0,
                        slidesPerRow: 1,
                        slidesToShow: l,
                        focusOnSelect: !1,
                        asNavFor: b,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        responsive: [{
                            breakpoint: 767,
                            settings: {
                                arrows: w
                            }
                        }]
                    })
                } else if (a.hasClass("productView-horizontal-tabs")) {
                    var c;
                    l = 2, d = 1;
                    (c = t.find(".productView-nav.productView-horizontal-tabs")).slick({
                        dots: !0,
                        rows: d,
                        arrows: m,
                        infinite: !0,
                        slidesPerRow: 1,
                        slidesToShow: l,
                        focusOnSelect: !1,
                        asNavFor: b,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        responsive: [{
                            breakpoint: 767,
                            settings: {
                                arrows: w
                            }
                        }]
                    })
                } else !a.is(".style-2, .style-3") || window.innerWidth < 768 ? (a.slick({
                    fade: !0,
                    dots: !1,
                    arrows: m,
                    infinite: !0,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    asNavFor: b,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            arrows: w
                        }
                    }]
                }), k = a) : k = !1;
                if (t.hasClass("layout-1") || t.hasClass("layout-2") ? (n.on("init", ((e, t) => {
                        n.find(".animated-loading").removeClass("animated-loading")
                    })), n.slick({
                        slidesToShow: v,
                        slidesToScroll: 1,
                        asNavFor: k,
                        arrows: !0,
                        dots: !1,
                        draggable: !1,
                        adaptiveHeight: !1,
                        focusOnSelect: !0,
                        vertical: !0,
                        verticalSwiping: !0,
                        infinite: !0,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        responsive: [{
                            breakpoint: 1600,
                            settings: {
                                slidesToShow: v > 3 ? v - 1 : v,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 1280,
                            settings: {
                                vertical: !1,
                                verticalSwiping: !1
                            }
                        }, {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                                vertical: !1,
                                verticalSwiping: !1
                            }
                        }]
                    })) : t.hasClass("layout-3") && (n.on("init", ((e, t) => {
                        n.find(".animated-loading").removeClass("animated-loading")
                    })), n.slick({
                        slidesToShow: v,
                        slidesToScroll: 1,
                        asNavFor: k,
                        arrows: !0,
                        dots: !1,
                        focusOnSelect: !0,
                        infinite: !0,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        responsive: [{
                            breakpoint: 1600,
                            settings: {
                                slidesToShow: v > 3 ? v - 1 : v,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1
                            }
                        }]
                    })), s.on("init", ((e, t) => {
                        s.find(".animated-loading").removeClass("animated-loading")
                    })), s.slick({
                        slidesToShow: parseInt(s.data("max-thumbnail-to-show")),
                        slidesToScroll: 1,
                        asNavFor: k,
                        arrows: !0,
                        dots: !1,
                        draggable: !1,
                        adaptiveHeight: !1,
                        focusOnSelect: !0,
                        vertical: !0,
                        verticalSwiping: !0,
                        infinite: !0,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        responsive: [{
                            breakpoint: 1600,
                            settings: {
                                slidesToShow: v > 3 ? v - 1 : v,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 1280,
                            settings: {
                                vertical: !1,
                                verticalSwiping: !1
                            }
                        }, {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2.2,
                                slidesToScroll: 1,
                                vertical: !1,
                                verticalSwiping: !1
                            }
                        }]
                    }), t.hasClass("layout-1") || t.hasClass("layout-2")) {
                    var p = n.outerHeight(),
                        u = (a.outerHeight() - p) / 2,
                        h = u + 80;
                    o.width() > 1279 ? n.find(".slick-arrow").length > 0 ? (n.parent().addClass("arrows-visible"), n.parent().css("top", u)) : (n.parent().addClass("arrows-disable"), n.parent().css("top", h)) : n.find(".slick-arrow").length > 0 ? n.parent().css("top", "unset") : n.parent().css("top", h)
                }
                if (a.find("[data-youtube]").length > 0)
                    if (void 0 === window.onYouTubeIframeAPIReady) {
                        window.onYouTubeIframeAPIReady = i.initYoutubeCarousel.bind(window, a);
                        const e = document.createElement("script");
                        e.src = "https://www.youtube.com/player_api";
                        const t = document.getElementsByTagName("script")[0];
                        t.parentNode.insertBefore(e, t)
                    } else i.initYoutubeCarousel(a);
                a.find("[data-vimeo]").length > 0 && (a.on("beforeChange", ((t, a) => {
                    var o, i;
                    i = {
                        method: "pause",
                        value: "true"
                    }, null != (o = e(a.$slider).find(".slick-current").find("iframe").get(0)) && o.contentWindow.postMessage(JSON.stringify(i), "*")
                })), a.on("afterChange", ((t, a) => {
                    var o, i;
                    i = {
                        method: "play",
                        value: "true"
                    }, null != (o = e(a.$slider).find(".slick-current").find("iframe").get(0)) && o.contentWindow.postMessage(JSON.stringify(i), "*")
                }))), a.find("[data-mp4]").length > 0 && (a.on("beforeChange", ((t, a) => {
                    var o;
                    null != (o = e(a.$slider).find(".slick-current").find("video").get(0)) && o.pause()
                })), a.on("afterChange", ((t, a) => {
                    var o;
                    null != (o = e(a.$slider).find(".slick-current").find("video").get(0)) && o.play()
                }))), window.innerWidth < 768 && f && (a.append('<div class="slick-counter">\n                                        <span class="slick-counter--current">1</span>\n                                        <span aria-hidden="true">/</span>\n                                        <span class="slick-counter--total">' + g + "</span>\n                                    </div>"), a.on("init reInit afterChange", (function(e, t, o, i) {
                    var n = (o || 0) + 1;
                    a.find(".slick-counter--current").text(n)
                })))
            }
            var m = t.find("[data-fancybox]");
            m.length > 0 && m.fancybox({
                buttons: ["zoom", "share", "slideShow", "fullScreen", "thumbs", "close"],
                loop: !0,
                thumbs: {
                    autoStart: !0
                }
            });
            var w = t.find("[data-zoom-image]");
            o.width() > 1024 && w.each(((t, a) => {
                var i = e(a);
                o.width() > 1024 ? i.zoom({
                    url: i.attr("data-zoom-image"),
                    touch: !1
                }) : i.trigger("zoom.destroy")
            })), o.on("resize", (() => {
                (t.hasClass("layout-1") || t.hasClass("layout-2")) && (o.width() > 1279 ? setTimeout((() => {
                    if (n.find(".slick-arrow").length > 0) {
                        var e = n.outerHeight(),
                            t = (a.outerHeight() - e) / 2;
                        n.parent().addClass("arrows-visible"), n.parent().css("top", t)
                    } else n.parent().addClass("arrows-disable")
                }), 200) : setTimeout((() => {
                    n.find(".slick-arrow").length > 0 && n.parent().css("top", "unset")
                }), 200))
            }))
        },
        productVideoGallery: function(a) {
            const i = a.find("[data-video-thumbnail]").length,
                n = e(".productView-video").length;
            if (i) {
                const i = a.find(".productView-image-wrapper"),
                    s = e("[data-popup-video]"),
                    r = a.find(".productView-nav");
                let l = i.offset().top + i.outerHeight();
                n && t.addClass("has-product-video"), o.on("scroll", (o => {
                    const i = e(o.currentTarget),
                        n = a.find(".slick-current .productView-video"),
                        d = n.data("type"),
                        c = n.data("video-url");
                    if (null != c)
                        if (i.scrollTop() > l) {
                            if (!s.is(".is-show")) {
                                const e = r.find(".slick-slide.slick-active").data("youtube-player"),
                                    a = parseInt(e.getCurrentTime()),
                                    o = `<div class="fluid-width-video-wrapper" style="padding-top: 56.24999999999999%">\n                                                    ${"youtube"==d?`<iframe\n                                                            id="player"\n                                                            type="text/html"\n                                                            width="100%"\n                                                            frameborder="0"\n                                                            webkitAllowFullScreen\n                                                            mozallowfullscreen\n                                                            allowFullScreen\n                                                            src="https://www.youtube.com/embed/${c}?autoplay=1&mute=1&start=${a}">\n                                                        </iframe>`:`<iframe \n                                                            src="https://player.vimeo.com/video/${c}?autoplay=1&mute=1" \n                                                            class="js-vimeo" \n                                                            allow="autoplay; \n                                                            encrypted-media" \n                                                            webkitallowfullscreen \n                                                            mozallowfullscreen \n                                                            allowfullscreen">\n                                                        </iframe>`}\n                                                </div>`;
                                s.addClass("is-show"), s.find(".halo-popup-content").html(o), t.addClass("video-show product-video-show"), e.pauseVideo()
                            }
                        } else {
                            const e = r.find(".slick-slide.slick-active").data("youtube-player");
                            s.removeClass("is-show"), s.find(".halo-popup-content").empty(), t.removeClass("video-show product-video-show"), e.playVideo()
                        }
                }))
            }
        },
        initVariantImageGroup: function(t, o = !1) {
            if (o) {
                var i = t.find("[data-filter]:checked"),
                    n = t.find(".productView-for"),
                    s = t.find(".productView-nav");
                if (i.length > 0) {
                    var r = i.data("filter");
                    void 0 !== r && (s.slick("slickUnfilter"), n.slick("slickUnfilter"), s.find(r).length && n.find(r).length && (s.slick("slickFilter", r).slick("refresh"), n.slick("slickFilter", r).slick("refresh")))
                }
                a.on("change", "input[data-filter]", (t => {
                    var a = e(t.currentTarget).data("filter");
                    s.slick("slickUnfilter"), n.slick("slickUnfilter"), void 0 !== a && s.find(a).length && n.find(a).length && (s.slick("slickFilter", a).slick("refresh"), n.slick("slickFilter", a).slick("refresh"))
                }))
            }
        },
        initYoutubeCarousel: function(t) {
            t.each(((t, a) => {
                const o = e(a);
                o.find("[data-youtube]").length > 0 && (o.addClass("slick-slider--video"), i.initYoutubeCarouselEvent(a))
            }))
        },
        initYoutubeCarouselEvent: function(t) {
            var o = e(t),
                i = o.find("[data-youtube]");

            function n(t) {
                e(t.target.getIframe()).closest(".slick-slide").data("youtube-player", t.target), setTimeout((function() {
                    e(t.target.getIframe()).closest(".slick-slide").hasClass("slick-active") && (o.slick("slickPause"), t.target.playVideo())
                }), 200)
            }

            function s(e) {
                e.data === YT.PlayerState.PLAYING && o.slick("slickPause"), e.data === YT.PlayerState.ENDED && o.slick("slickNext")
            }

            function r() {
                i.each(((t, a) => {
                    const o = e(a),
                        i = `youtube_player_${Math.floor(100*Math.random())}`;
                    o.attr("id", i);
                    new YT.Player(i, {
                        host: "http://www.youtube.com",
                        videoId: o.data("youtube"),
                        wmode: "transparent",
                        playerVars: {
                            autoplay: 0,
                            controls: 0,
                            disablekb: 1,
                            enablejsapi: 1,
                            fs: 0,
                            rel: 0,
                            showinfo: 0,
                            iv_load_policy: 3,
                            modestbranding: 1,
                            wmode: "transparent"
                        },
                        events: {
                            onReady: n,
                            onStateChange: s
                        }
                    })
                }))
            }

            function l() {
                const e = o.find(".slick-slide.slick-active").data("youtube-player");
                e && (e.stopVideo(), o.removeClass("slick-slider--playvideo"))
            }

            function d() {
                const e = o.find(".slick-slide.slick-active").data("youtube-player");
                e && (o.slick("slickPause"), o.addClass("slick-slider--playvideo"), e.playVideo())
            }! function() {
                o.hasClass("slick-initialized") && r();
                a.on("init", o, r), a.on("beforeChange", o, l), a.on("afterChange", o, d)
            }()
        },
        productSizeChart: function(o) {
            window.sizeChart = function() {
                o.find("[data-open-size-chart-popup]").on("click", (t => {
                    t.preventDefault(), t.stopPropagation(), document.body.classList.add("size-chart-show"), document.body.classList.contains("quick-view-show") ? e(".halo-popup-content .halo-size-chart-popup").addClass("is-show") : e("#MainContent .halo-size-chart-popup").addClass("is-show")
                })), a.on("click", "[data-close-size-chart-popup]", (() => {
                    t.removeClass("size-chart-show"), e(".halo-size-chart-popup").removeClass("is-show")
                })), a.on("click", (a => {
                    t.hasClass("size-chart-show") && 0 === e(a.target).closest("[data-open-size-chart-popup]").length && 0 === e(a.target).closest("[data-size-chart-popup]").length && t.removeClass("size-chart-show")
                }))
            };
            var i = document.body.classList.contains("quick-view-show"),
                n = e(".halo-productView .productView-sizeChart").length;
            document.body.classList.contains("template-product") ? (!i && n || i && 0 === n) && window.sizeChart() : window.sizeChart()
        },
        productLastSoldOut: function(e) {
            var t = e.find("[data-sold-out-product]");
            if (t.length > 0) {
                var a = t.data("item").toString().split(","),
                    o = Math.floor(Math.random() * a.length),
                    i = t.data("hours").toString().split(","),
                    n = Math.floor(Math.random() * i.length);
                t.find("[data-sold-out-number]").text(a[o]), t.find("[data-sold-out-hours]").text(i[n]), t.show()
            }
        },
        productCustomerViewing: function(e) {
            var t = e.find("[data-customer-view]");
            if (t.length > 0) {
                var a = t.data("customer-view"),
                    o = JSON.parse("[" + a + "]"),
                    i = t.data("customer-view-time"),
                    n = 1e3 * parseInt(i);
                setInterval((function() {
                    var e = Math.floor(Math.random() * o.length);
                    t.find(".text").text(window.customer_view.text.replace("[number]", o[e]))
                }), n)
            }
        },
        productCountdown: function(e) {
            var t = e.find("[data-countdown-id]"),
                a = t.data("countdown"),
                o = new Date(a).getTime(),
                i = window.countdown.text;
            if (t.length > 0) var n = setInterval((function() {
                var e = (new Date).getTime(),
                    a = o - e;
                if (a < 0) clearInterval(n), t.remove();
                else {
                    var s, r = Math.floor(a / 864e5),
                        l = Math.floor(a % 864e5 / 36e5),
                        d = Math.floor(a % 36e5 / 6e4),
                        c = Math.floor(a % 6e4 / 1e3);
                    s = t.is(".style-2, .style-3") ? '<span class="text"><span>' + i + '</span></span><span class="num">' + r + "<span>" + window.countdown.day_2 + '</span></span>                                <span class="num">' + l + "<span>" + window.countdown.hour_2 + '</span></span>                                <span class="num">' + d + "<span>" + window.countdown.min_2 + '</span></span>                                <span class="num">' + c + "<span>" + window.countdown.sec_2 + "</span></span>" : '<span class="text"><span>' + i + '</span></span><span class="num">' + r + "<span>" + window.countdown.day + '</span></span>                                <span class="num">' + l + "<span>" + window.countdown.hour + '</span></span>                                <span class="num">' + d + "<span>" + window.countdown.min + '</span></span>                                <span class="num">' + c + "<span>" + window.countdown.sec + "</span></span>", t.html(s)
                }
            }), 1e3)
        },
        productCustomCursor: function(t) {
            if (0 == e(".cursor-wrapper").length) return;
            const {
                Back: a
            } = window;
            this.cursorWrapper = document.querySelector(".cursor-wrapper"), this.innerCursor = document.querySelector(".custom-cursor__inner"), this.outerCursor = document.querySelector(".custom-cursor__outer"), this.cursorWrapperBox = this.cursorWrapper.getBoundingClientRect(), this.innerCursorBox = this.innerCursor.getBoundingClientRect(), this.outerCursorBox = this.outerCursor.getBoundingClientRect(), document.addEventListener("mousemove", (e => {
                this.clientX = e.clientX, this.clientY = e.clientY
            }));
            const o = () => {
                TweenMax.set(this.cursorWrapper, {
                    x: this.clientX,
                    y: this.clientY
                }), requestAnimationFrame(o)
            };
            requestAnimationFrame(o), this.fullCursorSize = 60, this.enlargeCursorTween = TweenMax.to(this.outerCursor, .3, {
                width: this.fullCursorSize,
                height: this.fullCursorSize,
                ease: this.easing,
                paused: !0
            });
            const i = () => {
                    this.enlargeCursorTween.play(), e(".cursor-wrapper").addClass("handleMouseEnter").removeClass("handleMouseLeave")
                },
                n = () => {
                    this.enlargeCursorTween.reverse(), e(".cursor-wrapper").addClass("handleMouseLeave").removeClass("handleMouseEnter")
                };
            document.querySelectorAll(".productView-image").forEach((e => {
                e?.querySelector(".productView-video") || (e.addEventListener("mouseenter", i), e.addEventListener("mouseleave", n))
            })), this.bumpCursorTween = TweenMax.to(this.outerCursor, .1, {
                scale: .7,
                paused: !0,
                onComplete: () => {
                    TweenMax.to(this.outerCursor, .2, {
                        scale: 1,
                        ease: this.easing
                    })
                }
            }), e(document).on("mouseover", "[data-cursor-image]", (t => {
                var a = e(t.currentTarget),
                    o = new Array;
                o.push(a.attr("data-index")), e("#count-image").text(o[0])
            })), e.fn.isInViewport = function(t) {
                var a = e(this).offset().top,
                    o = a + e(this).height(),
                    i = e(document).scrollTop(),
                    n = i + e(window).height();
                if (t) {
                    var s = (o - i) / e(this).height();
                    return o > i && a < n && s > .5
                }
                return o > i && a < n
            }, (e(".product-full-width").length > 0 || e(".product-full-width-2").length > 0) && e(window).on("resize scroll", (function() {
                var t = new Array;
                e(".productView-image").each((function() {
                    e(this).isInViewport(!0) && (t.push(e(this).attr("data-index")), e("#count-image").text(t[0]))
                }))
            }))
        },
        initWishlist: function() {
            window.wishlist.show && (i.setLocalStorageProductForWishlist(), a.on("click", "[data-wishlist]", (t => {
                t.preventDefault(), t.stopPropagation(), e("[data-wishlist-items-display]").removeClass("is-loaded");
                var a = e(t.currentTarget),
                    o = a.data("product-id"),
                    n = a.data("wishlist-handle"),
                    s = localStorage.getItem("wishlistItem") ? JSON.parse(localStorage.getItem("wishlistItem")) : [];
                index = s.indexOf(n), wishlistContainer = e("[data-wishlist-container]"), a.hasClass("wishlist-added") ? (a.removeClass("wishlist-added").find(".text").text(window.wishlist.add), wishlistContainer.length > 0 && e('[data-wishlist-added="wishlist-' + o + '"]').length > 0 && e('[data-wishlist-added="wishlist-' + o + '"]').remove(), s.splice(index, 1), localStorage.setItem("wishlistItem", JSON.stringify(s)), i.wishlistPagination(), wishlistContainer.length > 0 && ((s = localStorage.getItem("wishlistItem") ? JSON.parse(localStorage.getItem("wishlistItem")) : []).length > 0 ? i.updateShareWishlistViaMail() : (e("[data-wishlist-container]").addClass("is-empty").html(`                                    <div class="wishlist-content-empty text-center">                                        <span class="wishlist-content-text">${window.wishlist.empty}</span>                                        <div class="wishlist-content-actions">                                            <a class="button button-2 button-continue" href="${window.routes.collection_all}">                                                ${window.wishlist.continue_shopping}                                            </a>                                        </div>                                    </div>                                `), e("[data-wishlist-footer]").hide()))) : (a.addClass("wishlist-added").find(".text").text(window.wishlist.added), wishlistContainer.length > 0 && i.setProductForWishlistPage(n), s.push(n), localStorage.setItem("wishlistItem", JSON.stringify(s))), e("[data-wishlist-count]").text(s.length), i.setProductForWishlist(n)
            })))
        },
        wishlistPagination: function() {
            var t = localStorage.getItem("wishlistItem") ? JSON.parse(localStorage.getItem("wishlistItem")) : [],
                a = e("#wishlist-paginate");
            let o;
            o = 1 === window.pagination.style ? '<li class="pagination-arrow prev disabled style-1"><a href="#" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"><svg class="icon thin-arrow" viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></span></a></li>' : 2 === window.pagination.style ? '<li class="pagination-arrow prev disabled style-2"><a href="#" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></svg></span></a></li>' : '<li class="pagination-arrow prev disabled style-3"><a href="#" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></svg><span class="arrow-text">' + window.pagination.prev + "</span></a></li>";
            let i = e("[data-wishlist-items-display]");
            i.removeClass("is-loaded"), setTimeout((() => {
                a.children().remove();
                var n = Math.ceil(t.filter((e => null != e)).length / 3);
                if (n <= 1) return i.children().show(), void i.addClass("is-loaded");
                for (var s = 0; s < n; s++) {
                    var r = s + 1;
                    o += 0 === s ? '<li class="active pagination-num"><a class="pagination__item link" data-page="' + r + '" href="' + r + '" title="' + r + '">' + r + "</a></li>" : '<li class="pagination-num"><a class="pagination__item link" data-page="' + r + '" href="' + r + '" title="' + r + '">' + r + "</a></li>"
                }
                1 === window.pagination.style ? o += '<li class="pagination-arrow next style-1"><a href="#" class="pagination__item pagination__item--next pagination__item-arrow link"><svg class="icon thin-arrow" viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></span></a></li>' : 2 === window.pagination.style ? o += '<li class="pagination-arrow next style-2"><a href="#" class="pagination__item pagination__item--next pagination__item-arrow link"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></svg></span></a></li>' : o += '<li class="pagination-arrow next style-3"><a href="#" class="pagination__item pagination__item--next pagination__item-arrow link"><span class="arrow-text">' + window.pagination.next + '</span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></svg></span></a></li>', a.append(o), i.children().each((function(t, a) {
                    t >= 3 ? e(a).hide() : e(a).show()
                })), i.children().slice(3).css("display", "none"), a.off("click.wl-pagging").on("click.wl-pagging", "li a", (function(t) {
                    t.preventDefault();
                    var o = e(this).parent().hasClass("prev"),
                        s = e(this).parent().hasClass("next"),
                        r = e(this).data("page");
                    const l = parseInt(e(this).parent().siblings(".active").children().data("page"));
                    o && (r = l - 1), s && (r = l + 1), i.children().each((function(t, a) {
                        t >= 3 * (r - 1) && t < 3 * r ? e(a).show() : e(a).hide()
                    })), 1 === r ? (a.find(".prev").addClass("disabled"), a.find(".next").removeClass("disabled")) : r === n ? (a.find(".next").addClass("disabled"), a.find(".prev").removeClass("disabled")) : (a.find(".prev").removeClass("disabled"), a.find(".next").removeClass("disabled")), e(this).parent().siblings(".active").removeClass("active"), a.find('[data-page="' + r + '"]').parent().addClass("active")
                })), i.addClass("is-loaded")
            }), 500)
        },
        initWishlistPage: function() {
            if ("undefined" != typeof Storage) {
                var t = localStorage.getItem("wishlistItem") ? JSON.parse(localStorage.getItem("wishlistItem")) : [];
                t.length > 0 ? (t = JSON.parse(localStorage.getItem("wishlistItem"))).forEach(((e, t) => {
                    i.setProductForWishlistPage(e, t)
                })) : (e("[data-wishlist-container]").addClass("is-empty").html(`                        <div class="wishlist-content-empty text-center">                            <span class="wishlist-content-text">${window.wishlist.empty}</span>                            <div class="wishlist-content-actions">                                <a class="button button-2 button-continue" href="${window.routes.collection_all}">                                    ${window.wishlist.continue_shopping}                                </a>                            </div>                        </div>                    `), e("[data-wishlist-footer]").hide()), i.wishlistPagination()
            } else alert("Sorry! No web storage support..")
        },
        setProductForWishlistPage: function(t, a) {
            var o = e("[data-wishlist-container]");
            e.getJSON(window.routes.root + "/products/" + t + ".js", (e => {
                var t = "",
                    n = Shopify.formatMoney(e.price_min, window.money_format);
                t += '<div class="wishlist-row" data-wishlist-added="wishlist-' + e.id + '" data-product-id=product-' + e.id + '">', t += '<div class="wishlist-rowItem wishlist-image text-left">', t += '<div class="item">', t += '<a class="item-image" href="' + e.url + '"><img srcset="' + e.featured_image + '" alt="' + e.featured_image.alt + '"></a></div>', t += "</div>", t += '<div class="wishlist-rowItem wishlist-meta text-left">', t += '<div class="item">', t += '<div class="item-info"><a class="item-title link link-underline" href="' + e.url + '"><span class="text">' + e.title + "</span></a></div>", t += '<a class="item-vendor" href="' + window.routes.root + "/collections/vendors?q=" + e.vendor + '">' + e.vendor + "</a>", t += "</div></div>", t += '<div class="wishlist-rowItem wishlist-price text-left"><div class="item-price">' + n + "</div></div>", t += '<div class="wishlist-rowItem wishlist-add text-center">', t += '<form action="/cart/add" method="post" class="variants" id="wishlist-product-form-' + e.id + '" data-id="product-actions-' + e.id + '" enctype="multipart/form-data">', e.available ? (1 == e.variants.length && (t += '<button data-btn-addToCart class="item-btn button add-to-cart-btn"data-form-id="#wishlist-product-form-' + e.id + '" type="submit">' + window.variantStrings.addToCart + '</button><input type="hidden" name="id" value="' + e.variants[0].id + '" />'), e.variants.length > 1 && (t += '<a class="item-btn button" title="' + e.title + '" href="' + e.url + '">' + window.variantStrings.select + "</a>")) : t += '<button class="item-btn button add-to-cart-btn" type="submit" disabled>' + window.variantStrings.soldOut + "</button>", t += "</form></div>", t += '<div class="wishlist-rowItem wishlist-remove text-center"><a class="item-remove wishlist-added" href="#" data-wishlist-handle="' + e.handle + '" data-wishlist data-product-id="' + e.id + '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"/></svg></a></div>', t += "</div>", o.find(".wishlist-items-display").append(t), i.updateShareWishlistViaMail(), a == o.find("[data-wishlist-added]").length - 1 && i.updateShareWishlistViaMail()
            }))
        },
        updateShareWishlistViaMail: function() {
            const t = /(<([^>]+)>)/gi;
            var a, o, i, n, s = e("[data-wishlist-share]"),
                r = "mailto:?subject= Wish List&body=";
            e("[data-wishlist-added]").each(((s, l) => {
                a = e(l), n = a.find(".item-price .money").text(), o = a.find(".item-title .text").text(), i = a.find(".item-title").attr("href"), r += encodeURIComponent(o + "\nPrice: " + n.replace(t, "") + "\nLink: " + window.location.protocol + "//" + window.location.hostname + i + "\n\n")
            })), s.attr("href", r)
        },
        setProductForWishlist: function(t) {
            var a = JSON.parse(localStorage.getItem("wishlistItem")),
                o = e('[data-wishlist-handle="' + t + '"]');
            a.indexOf(t) >= 0 ? o.addClass("wishlist-added").find(".text").text(window.wishlist.added) : o.removeClass("wishlist-added").find(".text").text(window.wishlist.add)
        },
        setLocalStorageProductForWishlist: function() {
            var t = localStorage.getItem("wishlistItem") ? JSON.parse(localStorage.getItem("wishlistItem")) : [];
            localStorage.setItem("wishlistItem", JSON.stringify(t)), t.length > 0 && (t = JSON.parse(localStorage.getItem("wishlistItem"))).forEach((e => {
                i.setProductForWishlist(e)
            })), e("[data-wishlist-count]").text(t.length)
        },
        initCountdown: function() {
            var t = e("[data-countdown]").not("[data-countdown-id]");
            t.length && t.each((function() {
                var t = e(this),
                    a = t.data("countdown-value");
                countDownDate = new Date(a).getTime(), countDownText = window.countdown.text;
                var o = setInterval((function() {
                    var a = (new Date).getTime(),
                        i = countDownDate - a;
                    if (i < 0) clearInterval(o), t.hasClass("hide--countdown") ? t.remove() : t.parents(".shopify-section").remove();
                    else {
                        var n = Math.floor(i / 864e5),
                            s = `0${Math.floor(i%864e5/36e5)}`.slice(-2),
                            r = `0${Math.floor(i%36e5/6e4)}`.slice(-2),
                            l = `0${Math.floor(i%6e4/1e3)}`.slice(-2),
                            d = "";
                        d = t.hasClass("product-countdown-block") ? e(".halo-block-header").hasClass("countdown_style_2") ? '<div class="clock-item"><span class="num">' + n + window.countdown.d + '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' + s + window.countdown.h + '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' + r + window.countdown.m + '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' + l + window.countdown.s + '</span><span class="icon"></span></div>' : `<div class="clock-item"><span class="num">${n}d&nbsp;</span></div>\n                                    <div class="clock-item"><span class="num">${s}:</span></div>\n                                    <div class="clock-item"><span class="num">${r}:</span></div>\n                                    <div class="clock-item"><span class="num">${l}</span></div>` : '<div class="clock-item"><span class="num">' + n + '</span><span class="text">' + window.countdown.days + '</span></div>                                                <div class="clock-item"><span class="num">' + s + '</span><span class="text">' + window.countdown.hours + '</span></div>                                                <div class="clock-item"><span class="num">' + r + '</span><span class="text">' + window.countdown.mins + '</span></div>                                                <div class="clock-item"><span class="num">' + l + '</span><span class="text">' + window.countdown.secs + "</span></div>", t.html(d)
                    }
                }), 1e3)
            }))
        },
        collectionCountdown: function() {
            var t = e("[data-collection-countdown]");
            t.length && t.each((function() {
                var t = e(this),
                    a = e => {
                        var t = e.data("collection-countdown-value"),
                            o = new Date(t).getTime(),
                            i = (window.countdown.text, o - (new Date).getTime());
                        if (i < 0) clearInterval(a), e.hasClass("hide--countdown") ? e.remove() : e.parents(".shopify-section").remove();
                        else {
                            var n = Math.floor(i / 864e5),
                                s = `0${Math.floor(i%864e5/36e5)}`.slice(-2),
                                r = `0${Math.floor(i%36e5/6e4)}`.slice(-2),
                                l = `0${Math.floor(i%6e4/1e3)}`.slice(-2),
                                d = "";
                            e.hasClass("collection-countdown") && (d = '<div class="clock-item"><span class="num">' + n + '</span><span class="text">' + window.countdown.days + '</span></div>                                                <div class="clock-item"><span class="num">' + s + '</span><span class="text">' + window.countdown.hours + '</span></div>                                                <div class="clock-item"><span class="num">' + r + '</span><span class="text">' + window.countdown.mins + '</span></div>                                                <div class="clock-item"><span class="num">' + l + '</span><span class="text">' + window.countdown.secs + "</span></div>"), e.html(d)
                        }
                    };
                setInterval((() => {
                    a(t)
                }), 1e3)
            }))
        },
        handleScrollDown: function() {
            var t = "[data-scroll-down]",
                a = e(t);
            a.each((function() {
                var t = e(this),
                    o = t.closest(".shopify-section").next(".shopify-section").attr("id");
                t.attr("href", "#" + o), a.on("click", (function(t) {
                    t.preventDefault();
                    var a = e(this.getAttribute("href"));
                    a.length && e("html, body").stop().animate({
                        scrollTop: a.offset().top
                    }, 400)
                }))
            }))
        },
        toggleSidebarMobile: function() {
            a.on("click", "[data-sidebar]", (e => {
                e.preventDefault(), e.stopPropagation(), t.addClass("open-mobile-sidebar")
            })), a.on("click", "[data-close-sidebar]", (e => {
                e.preventDefault(), e.stopPropagation(), t.removeClass("open-mobile-sidebar")
            })), a.on("click", (a => {
                t.hasClass("open-mobile-sidebar") && 0 === e(a.target).closest("[data-sidebar]").length && 0 === e(a.target).closest("#halo-sidebar").length && t.removeClass("open-mobile-sidebar")
            }))
        },
        initBlogMasonry: function() {
            e(".blog-layout-masonry .blog-block-item").masonry({
                columnWidth: ".blog-grid-sizer",
                itemSelector: "[data-masonry-item]"
            })
        },
        articleGallery: function() {
            const t = e(".articleGallery-block"),
                a = e(".articleGallery-slider"),
                o = t.length,
                i = a.data("col");
            o > 0 && a.not(".slick-initialized") && a.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: !0,
                arrows: !0,
                infinite: !1,
                mobileFirst: !0,
                focusOnSelect: !1,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: i,
                        slidesToScroll: i
                    }
                }, {
                    breakpoint: 319,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }]
            })
        },
        initCollapseSidebarBlock: function() {
            a.on("click", ".sidebarBlock-headingWrapper .sidebarBlock-heading", (t => {
                var a = e(t.currentTarget),
                    o = a.parent().siblings(),
                    i = a.parents(".sidebarBlock");
                a.hasClass("is-clicked") ? (a.removeClass("is-clicked"), o.slideUp("slow")) : (a.addClass("is-clicked"), o.slideDown("slow"), i.hasClass("sidebar-product") && i.find(".products-carousel").slick("refresh"))
            }))
        },
        initCategoryActive: function() {
            e(".all-categories-list").length > 0 && (a.on("click", ".all-categories-list .icon-dropdown", (t => {
                var a = e(t.currentTarget).parent();
                a.siblings().removeClass("is-clicked current-cate"), a.toggleClass("is-clicked"), a.siblings().find("> .dropdown-category-list").slideUp("slow"), a.find("> .dropdown-category-list").slideToggle("slow")
            })), e(".all-categories-list li").each(((t, a) => {
                e(a).hasClass("current-cate") && e(a).find("> .dropdown-category-list").slideToggle("slow")
            })))
        },
        productBlockSilderSidebar: function() {
            var t = e("[data-product-slider-sidebar]"),
                a = t.data("item-to-show"),
                o = t.data("item-dots"),
                i = t.data("item-arrows");
            t.length > 0 && t.not(".slick-initialized") && t.slick({
                mobileFirst: !0,
                adaptiveHeight: !0,
                vertical: !1,
                infinite: !1,
                slidesToShow: a,
                slidesToScroll: 1,
                arrows: i,
                dots: o,
                autoplay: !0,
                autoplaySpeed: 2e3,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev
            })
        },
        productBlockSilderArticle: function() {
            var t = e("[data-product-slider-article]"),
                a = t.data("item-to-show"),
                o = t.data("item-dots"),
                i = t.data("item-arrows");
            t.length > 0 && t.not(".slick-initialized") && t.slick({
                adaptiveHeight: !0,
                vertical: !1,
                infinite: !1,
                slidesToShow: a,
                slidesToScroll: 1,
                arrows: i,
                dots: o,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 551,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }]
            })
        },
        articleGallery: function() {
            const t = e(".articleGallery-block"),
                a = e(".articleGallery-slider"),
                o = t.length,
                i = a.data("col");
            o > 0 && a.not(".slick-initialized") && a.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: !0,
                arrows: !0,
                infinite: !1,
                mobileFirst: !0,
                focusOnSelect: !1,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: i,
                        slidesToScroll: i
                    }
                }, {
                    breakpoint: 319,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }]
            })
        },
        initInfiniteScrolling: function() {
            e(!0) && o.on("scroll load", (() => {
                var t = o.scrollTop(),
                    a = e(".pagination-infinite"),
                    n = a.find("[data-infinite-scrolling]");
                if (n.length > 0 && !n.hasClass("is-loading") && t > a.offset().top - 500) {
                    var s = n.attr("href");
                    i.doAjaxInfiniteScrollingGetContent(s, n)
                }
            })), a.on("click", "[data-infinite-scrolling]", (t => {
                var a = e(t.currentTarget),
                    o = a.attr("href");
                t.preventDefault(), t.stopPropagation(), i.doAjaxInfiniteScrollingGetContent(o, a)
            }))
        },
        doAjaxInfiniteScrollingGetContent: function(t, a) {
            e.ajax({
                type: "GET",
                url: t,
                beforeSend: function() {
                    a.text(a.attr("data-loading-more")), a.addClass("is-loading")
                },
                success: function(e) {
                    i.ajaxInfiniteScrollingMapData(e)
                },
                error: function(t, a) {
                    alert(e.parseJSON(t.responseText).description)
                },
                complete: function() {
                    a.text(a.attr("data-load-more")), a.removeClass("is-loading"), document.querySelector(".collection-masonry") && resizeAllGridItems()
                }
            })
        },
        ajaxInfiniteScrollingMapData: function(t) {
            var a = e("#CollectionProductGrid"),
                o = a.find(".productListing"),
                n = a.find(".pagination"),
                s = e(t).find("#CollectionProductGrid"),
                r = s.find(".productListing"),
                l = s.find(".pagination"),
                d = r.children(".product");
            if (d.length > 0) {
                if (o.append(d), n.replaceWith(l), e("[data-total-start]").text(1), window.compare.show) {
                    var c = e("a[data-compare-link]");
                    i.setLocalStorageProductForCompare(c)
                }
                window.wishlist.show && i.setLocalStorageProductForWishlist(), i.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, e("#currencies .active").attr("data-currency"), "span.money", "money_format")
            }
        },
        initQuickShopProductList: function() {
            a.on("click", "[data-open-quickshop-popup-list]", (t => {
                t.preventDefault(), t.stopPropagation();
                var a = e(t.currentTarget).data("product-handle"),
                    o = e(t.currentTarget).closest(".card");
                o.hasClass("quick-shop-show") || i.updateContentQuickShop(o, a)
            })), a.on("click", "[data-close-quickshop-popup-list]", (t => {
                t.preventDefault(), t.stopPropagation();
                var a = e(t.currentTarget).closest(".card");
                a.removeClass("quick-shop-show"), a.find(".card-popup-content").empty()
            })), a.on("click", (t => {
                e(".card").hasClass("quick-shop-show") && 0 === e(t.target).closest("[data-open-quickshop-popup-list]").length && 0 === e(t.target).closest(".card-popup").length && (e(".card").removeClass("quick-shop-show"), e(".card").find(".card-popup-content").empty())
            }))
        },
        updateContentQuickShop: function(t, a) {
            var o = t.find(".card-popup").find(".card-popup-content");
            e.ajax({
                type: "get",
                url: window.routes.root + "/products/" + a + "?view=ajax_quick_shop",
                beforeSend: function() {
                    e(".card").removeClass("quick-shop-show")
                },
                success: function(e) {
                    o.append(e)
                },
                error: function(t, a) {
                    alert(e.parseJSON(t.responseText).description)
                },
                complete: function() {
                    t.addClass("quick-shop-show")
                }
            })
        },
        toggleVariantsForExpressOrder: function() {
            e(document).on("click", "[data-toggle-variant]", (function(t) {
                t.preventDefault(), t.stopPropagation();
                var a = e(this),
                    o = a.data("target");
                a.hasClass("show-options-btn") ? (a.text(window.inventory_text.hide_options), e(o).slideDown(700, (function() {
                    a.addClass("hide-options-btn").removeClass("show-options-btn")
                }))) : (a.text(window.inventory_text.show_options), e(o).slideUp(700, (function() {
                    a.addClass("show-options-btn").removeClass("hide-options-btn")
                })))
            }))
        },
        initExpressOrderAddToCart: function() {
            var t = "[data-express-addtocart]";
            e(document).off("click.addToCartExpress", t).on("click.addToCartExpress", t, (function(t) {
                t.preventDefault();
                var a = e(this);
                if ("disabled" != a.attr("disabled")) {
                    var o = a.closest(".product-item");
                    0 == o.length && (o = a.closest(".col-options"));
                    var n = o.find("form"),
                        s = n.find("select[name=id]").val();
                    s || (s = n.find("input[name=id]").val());
                    var r = o.find("input[name=quantity]");
                    0 == r.length && (r = o.siblings(".col-qtt").find("input[name=quantity]"));
                    var l = r.val();
                    l || (l = 1), 0 !== parseInt(l) ? "none" == window.ajax_cart ? n.submit() : (i.expressAjaxAddToCart(s, l, a, n), n.next(".feedback-text").show()) : n.next(".feedback-text").text("Quantity cannot be blank").show()
                }
                return !1
            }))
        },
        expressAjaxAddToCart: function(a, o, n, s) {
            e.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + o + "&id=" + a,
                dataType: "json",
                beforeSend: function() {
                    window.setTimeout((function() {
                        n.text(window.inventory_text.adding + "...")
                    }), 100)
                },
                success: function(e) {
                    switch (window.setTimeout((function() {
                            n.text(window.inventory_text.thank_you), n.addClass("add_more"), s.next(".feedback-text").text(window.inventory_text.cart_feedback).addClass("is-added")
                        }), 600), window.setTimeout((function() {
                            n.text(window.inventory_text.add_more + "...")
                        }), 1e3), window.after_add_to_cart.type) {
                        case "cart":
                            i.redirectTo(window.routes.cart);
                            break;
                        case "quick_cart":
                            window.quick_cart.show ? Shopify.getCart((e => {
                                "popup" == window.quick_cart.type || (t.addClass("cart-sidebar-show"), i.updateSidebarCart(e))
                            })) : i.redirectTo(window.routes.cart);
                            break;
                        case "popup_cart_1":
                            Shopify.getCart((e => {
                                i.updatePopupCart(e, 1), i.updateSidebarCart(e), t.addClass("add-to-cart-show")
                            }))
                    }
                },
                error: function(t, a) {
                    alert(e.parseJSON(t.responseText).description), window.setTimeout((function() {
                        n.text(window.inventory_text.add_to_cart)
                    }), 400)
                }
            })
        },
        initProductBundle: function() {
            var t = e("[data-product-bundle]"),
                a = t.find("[data-bundle-slider]"),
                o = a.data("dots"),
                i = a.data("arrows");
            a.length > 0 && (a.hasClass("slick-initialized") || (a.slick({
                dots: !0,
                arrows: i,
                slidesToShow: 2,
                slidesToScroll: 1,
                mobileFirst: !0,
                infinite: !1,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        dots: o
                    }
                }, {
                    breakpoint: 551,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        dots: o
                    }
                }]
            }), t.find(".bundle-product-wrapper").removeClass("has-halo-block-loader"), a.on("afterChange", (function() {
                a.find(".bundle-product-item").removeClass("is-open")
            }))))
        },
        initProductReviewSection: function() {
            a.ready((() => {
                setTimeout((() => {
                    const t = e(".productView-review .spr-content"),
                        a = e(".shopify-app-block .spr-content");
                    if (t && a) {
                        const e = t.html();
                        a.html(e)
                    }
                }), 1e3)
            }))
        },
        initDynamicBrowserTabTitle: function() {
            if (window.dynamic_browser_title.show) {
                var e = document.title;
                window.dynamic_browser_title.text;
                window.onblur = function() {
                    document.title = window.dynamic_browser_title.text
                }, window.onfocus = function() {
                    document.title = e
                }
            }
        },
        initWarningPopup: function() {
            this.warningPopup = document.querySelector("[data-warning-popup]"), this.warningPopupContent = this.warningPopup.querySelector("[data-halo-warning-content]"), this.warningPopupCloseButton = this.warningPopup.querySelector("[data-close-warning-popup]"), this.warningPopupCloseButton.addEventListener("click", (() => {
                document.body.classList.remove("has-warning")
            })), this.warningTime = 3e3, this.warningTimeout = void 0, window.warningTimeout = this.warningTimeout
        },
        showWarning: function(e, t = this.warningTime) {
            this.warningTimeout && clearTimeout(this.warningTimeout), this.warningPopupContent.textContent = e, document.body.classList.add("has-warning"), t && (this.warningTimeout = setTimeout((() => {
                document.body.classList.remove("has-warning")
            }), t))
        },
        initBannerAnimation: function() {
            const t = new IntersectionObserver(((e, t) => {
                e.forEach((e => {
                    if (e.isIntersecting) {
                        const a = e.target,
                            o = a.closest(".shopify-section");
                        if (a.classList.add("shouldShow"), o.classList.contains("observed") || o.classList.add("observed"), null != a.closest(".instagram-slide")) {
                            a.closest(".instagram-slide").querySelectorAll(".halo-item").forEach((e => e.classList.add("shouldShow")))
                        }
                        t.unobserve(e.target)
                    }
                }))
            }), {
                threshold: .25
            });
            var a = window.setInterval((function() {
                if ("function" == typeof e.fn.slick) {
                    const e = [{
                        klass: ".spotlight-block",
                        type: ".halo-item"
                    }, {
                        klass: ".halo-collection-content",
                        type: ".halo-item"
                    }, {
                        klass: ".instagram-slide",
                        type: ".halo-item"
                    }, {
                        klass: ".featured-blog-block",
                        type: [".blog-block", ".halo-item"]
                    }, {
                        klass: ".container.has-bg-image",
                        type: null
                    }, {
                        klass: ".contact-container",
                        type: null
                    }, {
                        klass: ".product-block-has__banner .product-block__banner",
                        type: null
                    }, {
                        klass: ".featured-collection-block",
                        type: ".halo-item"
                    }, {
                        klass: ".custom-image-banner-block",
                        type: ".halo-item"
                    }, {
                        klass: ".product-tab--block-has__banner .product-block__banner",
                        type: null
                    }, {
                        klass: ".block-banner-slider",
                        type: ".banner"
                    }, {
                        klass: ".policies-block-wrapper",
                        type: ".halo-item"
                    }, {
                        klass: ".brands-block",
                        type: ".halo-item"
                    }, {
                        klass: ".brands-slider",
                        type: ".brand-image-container"
                    }, {
                        klass: ".halo-banner-wrapper",
                        type: ".item"
                    }, {
                        klass: ".customer-review-block",
                        type: ".halo-item"
                    }];
                    document.querySelectorAll(".slideshow").forEach((e => {
                        if (e.classList.contains("slick-initialized")) i.enableSlideshowAnimationWithSlick(e);
                        else {
                            e.querySelectorAll(".item").forEach((e => {
                                t.observe(e)
                            }))
                        }
                    })), e.forEach((e => {
                        let a = document.querySelectorAll(e.klass);
                        a.length > 0 && a.forEach((a => {
                            if (!(a.classList.contains("slideshow") && a.querySelectorAll(".item").length > 1))
                                if (null == e.type) t.observe(a);
                                else {
                                    a.querySelectorAll(e.type).forEach((e => {
                                        t.observe(e)
                                    }))
                                }
                        }))
                    }));
                    document.querySelectorAll(".button").forEach((e => {
                        e.removeEventListener("transitionend", i.bannerButtonTransitionEnd), e.addEventListener("transitionend", i.bannerButtonTransitionEnd)
                    }));
                    document.querySelectorAll(".image-zoom").forEach((e => {
                        e.addEventListener("transitionend", (() => {
                            e.classList.add("image-animated")
                        }))
                    })), i.slideArrowTransitionEnd(), window.clearInterval(a)
                }
            }), 300)
        },
        enableSlideshowAnimationWithSlick: function(t) {
            var a = e(t).find(".slick-slide"),
                o = a.eq(0),
                n = a.find(".button");
            e(t).find(".slick-dots"), e(t).find(".slick-arrow");
            o.addClass("shouldShow"), setTimeout((() => {
                t.closest(".shopify-section").classList.add("observed")
            }), 300);
            var s = function(e) {
                e.each(((e, t) => {
                    null != t.closest(".enable_border_color") ? t.classList.add("banner-button-animated") : (t.removeEventListener("transitionend", i.bannerButtonTransitionEnd), t.addEventListener("transitionend", i.bannerButtonTransitionEnd))
                }))
            };
            s(o.find(".button")), e(t).on("beforeChange", (function(e, t, o, i) {
                a.removeClass("shouldShow"), n.removeClass("banner-button-animated"), a.eq(i).addClass("shouldShow"), s(a.eq(i).find(".button"))
            }))
        },
        slideArrowTransitionEnd: function() {
            document.addEventListener("transitionend", (e => {
                if (e.target.matches(".slick-arrow")) {
                    const t = e.target.closest(".shopify-section");
                    if (!t?.classList.contains("observed")) return;
                    e.target.classList.add("banner-action-animated")
                }
            }))
        },
        bannerButtonTransitionEnd: function(e) {
            const t = e.target,
                a = [{
                    grandParentKlass: ".slideshow",
                    parentKlass: ".item"
                }, {
                    grandParentKlass: ".spotlight-block",
                    parentKlass: ".halo-item"
                }, {
                    grandParentKlass: ".product-block-has__banner",
                    parentKlass: ".product-block__banner"
                }, {
                    grandParentKlass: ".halo-row",
                    parentKlass: ".halo-item"
                }, {
                    grandParentKlass: ".halo-banner-wrapper",
                    parentKlass: ".item"
                }, {
                    grandParentKlass: ".custom-image-banner-block",
                    parentKlass: ".halo-item"
                }].find((e => null != t.closest(e.grandParentKlass)));
            if (null != a) {
                const e = t.closest(a.parentKlass);
                e?.classList.contains("shouldShow") || e?.parentElement.classList.contains("shouldShow") ? t?.classList.add("banner-button-animated") : t?.classList.remove("banner-button-animated")
            }
        },
        backgroundOverlayHoverEffect: function() {
            const e = document.querySelector(".background-overlay"),
                t = document.querySelector(".background-cursor-wrapper"),
                a = () => {
                    t.classList.remove("enlarge-cursor")
                },
                o = (e, a) => {
                    requestAnimationFrame((() => {
                        t.style.setProperty("--translate-y", a), t.style.setProperty("--translate-x", e)
                    }))
                },
                i = e => {
                    o(e.clientX, e.clientY)
                };
            e.addEventListener("mouseenter", (e => {
                o(e.clientX, e.clientY), t.classList.add("enlarge-cursor")
            })), e.addEventListener("mouseleave", (e => {
                o(e.clientX, e.clientY), t.removeEventListener("mousemove", i), a()
            })), e.addEventListener("mousemove", i), e.addEventListener("click", a)
        },
        initDragToScroll: function(e) {
            const t = e.querySelector("[data-drag-parent]");
            var a;
            (a = e).clientWidth < a.scrollWidth ? this.dragToScroll(e) : this.dragToScroll(t)
        },
        dragToScroll: function(e) {
            let t, a, o, i = !1;
            e.addEventListener("mousedown", (o => {
                o.target;
                i = !0, t = o.pageX - e.offsetLeft, a = e.scrollLeft
            })), e.addEventListener("mouseup", (() => {
                i = !1, clearTimeout(o), o = setTimeout((() => {
                    e.classList.remove("active")
                }), 150)
            })), e.addEventListener("mousemove", (o => {
                if (!i) return;
                o.preventDefault(), e.classList.contains("active") || e.classList.add("active");
                const n = 1 * (o.pageX - e.offsetLeft - t);
                e.scrollLeft = a - n
            })), e.addEventListener("mouseleave", (() => {
                i = !1, clearTimeout(o), o = setTimeout((() => {
                    e.classList.remove("active")
                }), 150)
            }))
        },
        productBlockScroller: function(e) {
            const {
                Back: t
            } = window, a = t.easeInOut.config(1.7);
            let o = e.get(0)?.querySelector(".products-cursor");
            if (!o) return;
            o.querySelector(".products-cursor__inner");
            let i, n, s = o.querySelector(".products-cursor__image"),
                r = o.querySelector(".products-cursor__icon"),
                l = e.get(0)?.querySelectorAll(".halo-block-content.is-scroll"),
                d = e.get(0)?.querySelectorAll(".card-product__group, .card-action, .card-title, .card-swatch, .variants-popup, .card-compare, .card-quickview, .card-wishlist");
            document.addEventListener("mousemove", (e => {
                i = e.clientX, n = e.clientY, docClientX = e.clientX, docClientY = e.clientY
            }));
            const c = () => {
                TweenMax.set(o, {
                    x: i,
                    y: n
                }), requestAnimationFrame(c)
            };
            requestAnimationFrame(c);
            const p = TweenMax.to([o], .1, {
                    scale: 2.5,
                    opacity: 1,
                    backgroundColor: "rgba(42,104,118,1)",
                    ease: a,
                    paused: !0
                }),
                u = TweenMax.to([s, r], .1, {
                    opacity: 1,
                    ease: a,
                    paused: !0
                }),
                h = e => {
                    p.play(), u.play(), o.classList.add("handleMouseEnter"), o.classList.remove("handleMouseLeave")
                },
                m = e => {
                    p.reverse(), u.reverse(), o.classList.add("handleMouseLeave"), o.classList.remove("handleMouseEnter")
                };
            l.forEach((e => {
                e.addEventListener("mouseenter", h), e.addEventListener("mouseleave", m)
            })), d.forEach((e => {
                e.addEventListener("mouseenter", m), e.addEventListener("mouseleave", h)
            }))
        },
        productCustomInformation() {
            const o = e("[data-custom-information]"),
                i = e("#halo-product-custom-information");
            o.on("click", (a => {
                const o = e(a.currentTarget),
                    n = o.find(".title")[0].innerText,
                    s = o.find(".product-customInformation__popup").html();
                i.addClass("is-show"), i.find(".halo-popup-title").text(n), i.find(".halo-popup-content").html(s), t.addClass("is-custom-information")
            })), a.on("click", "[data-close-custom-information]", (() => {
                t.removeClass("is-custom-information"), i.removeClass("is-show")
            })), a.on("click", (a => {
                t.hasClass("is-custom-information") && 0 === e(a.target).closest("#halo-product-custom-information").length && 0 === e(a.target).closest("[data-custom-information]").length && t.removeClass("is-custom-information")
            }))
        },
        initBreadcrumbFadeout(e) {
            const t = new IntersectionObserver((e => {
                    e.forEach((e => {
                        const t = e.target.closest(".breadcrumb-container");
                        e.isIntersecting ? t.classList.add("disable-last") : t.classList.remove("disable-last")
                    }))
                }), {
                    threshold: .6
                }),
                a = new IntersectionObserver((e => {
                    e.forEach((e => {
                        const t = e.target.closest(".breadcrumb-container");
                        e.isIntersecting ? t.classList.add("disable-first") : t.classList.remove("disable-first")
                    }))
                }), {
                    threshold: 1
                });
            e.forEach((e => {
                (e => {
                    const o = e.querySelector(".link.home-link"),
                        i = e.querySelector(".observe-element");
                    setTimeout((() => {
                        e.classList.add("initialized")
                    }), 300), t.observe(i), a.observe(o)
                })(e)
            }))
        },
        initLazyloadObserver(e, t) {
            const a = e => {
                e.closest(".card").classList.add("ajax-loaded")
            };
            this.lazyloadedObserver = new MutationObserver(((e, t) => {
                e.forEach((e => {
                    if ("attributes" == e.type) {
                        if (!e.target.classList.contains("lazyloaded")) return;
                        a(e.target)
                    }
                }))
            }));
            const o = new MutationObserver((e => {
                e.forEach((e => {
                    if ("childList" == e.type) {
                        [...e.addedNodes].map((e => e.querySelector(".media--loading-effect img"))).forEach((e => {
                            this.lazyloadedObserver.observe(e, {
                                childList: !0,
                                attributes: !0
                            })
                        }))
                    }
                }))
            }));
            t && o.observe(t, {
                subtree: !1,
                childList: !0
            }), e.length > 0 && e.forEach((e => {
                e.classList.contains("lazyloaded") ? a(e) : this.lazyloadedObserver.observe(e, {
                    childList: !0,
                    attributes: !0
                })
            }))
        },
        observeImageLazyloaded(e) {
            e.forEach((e => {
                this.lazyloadedObserver.observe(e, {
                    childList: !0,
                    attributes: !0
                })
            }))
        },
        iconZoomClickMobile() {
            e(".productView-iconZoom").on("click", (e => {
                document.querySelector(".productView-image .productView-img-container .media").click()
            }))
        }
    }
}(jQuery);